import React from 'react';
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';
import {
  compose,
  setPropTypes,
  withState,
  lifecycle,
  withHandlers
} from 'recompose';
import { withRouter } from 'react-router';
import { withStyles } from '@material-ui/core/styles';
// import Iframe from 'react-iframe';
import { Text } from 'recharts';
import Table from '@material-ui/core/Table';
import TableBody from '@material-ui/core/TableBody';
import TableCell from '@material-ui/core/TableCell';
import { Grid, TableRow } from '@material-ui/core';
import Paper from '@material-ui/core/Paper';
import Typography from '@material-ui/core/Typography';
import MuiAccordion from '@material-ui/core/Accordion';
import MuiAccordionSummary from '@material-ui/core/AccordionSummary';
import MuiAccordionDetails from '@material-ui/core/AccordionDetails';
import TextField from '@material-ui/core/TextField';
import ExpandMoreIcon from '@material-ui/icons/ExpandMore';
import Modal from '@material-ui/core/Modal';
import Button from '@material-ui/core/Button';
import Box from '@material-ui/core/Box';
import classNames from 'classnames';
import ReadMoreReact from 'read-more-react';
import ReplyIcon from '@material-ui/icons/Reply';
import ErrorIcon from '@material-ui/icons/Error';
import List from '@material-ui/core/List';
import ListItem from '@material-ui/core/ListItem';
import ArrowForwardIosIcon from '@material-ui/icons/ArrowForwardIos';
import Parser from 'rss-parser';
import renderHTML from 'react-render-html';
import Header from '../../components/Header';
import MenuBox from '../../components/MenuBox';
import ShopOpenButton from '../../components/atoms/ShopOpenButton';
import DetailTextButton from '../../components/atoms/DetailTextButton';
import EditTextButton from '../../components/atoms/EditTextButton';
import CoppyButton from '../../components/atoms/CoppyButton';
import ShopOpen from '../organisms/ShopOpen';
import { isAuthenticated, sendLogin } from '../../auth/Auth';
import { getAccounts } from '../../actions/Accounts';
import { postShopReply, postShashokuShopReply } from '../../actions/Gochis';
import {
  getTopPageInfo,
  getFirstLoginAfterReleaseShop,
  putFirstLoginAfterReleaseShop,
  GET_FIRST_LOGIN_AFTER_RELEASE_SUCCESS
} from '../../actions/TopPage';
import GochiMenuTableShop from '../organisms/GochiMenuTableShop';
import ShopEditShop from '../organisms/ShopEditShop';
import ShopDetailShop from '../organisms/ShopDetailShop';
import {
  getShopDetail,
  getShops,
  getGochiTipSummary,
  getGochiTipUrl
} from '../../actions/Shop';
import NotifyPopupShop from '../../components/molecules/NotifyPopupShop';
import ProgressDialog from '../../components/molecules/ProgressDialog';
import MenuRegisterButton from '../../components/atoms/MenuRegisterButton';
import GochiMenuAddShop from '../organisms/GochiMenuAddShop';
import DetailPostModal from '../../components/molecules/DetailPostModal';
import enabledStripeBilling from '../../constants/StripeBilling';
import {
  getMenuGenreOption,
  getMenuSituationOption,
  getMenuUserTargetOption
} from '../../actions/Options';
import ShopInvoiceButton from '../../components/atoms/ShopInvoiceButton';
import {
  GET_BANK_BRANCH_LIST_SUCCESS,
  GET_BANK_LIST_SUCCESS,
  getBankList,
  getBankBranchList
} from '../../actions/Bank';
import GochiMenuAddChooseUsageTypeShop from '../organisms/GochiMenuAddChooseUsageTypeShop';
import PolicyFirstLoginShopDialog from '../../components/molecules/PolicyFirstLoginShopDialog';
import { nameSystem } from '../../constants/TextSystem';

const Accordion = withStyles({
  root: {
    border: 0,
    boxShadow: 'none',
    '&::before': {
      display: 'none'
    },
    '&$expanded': {
      margin: 'auto'
    }
  },
  expanded: {}
})(MuiAccordion);

const AccordionSummary = withStyles({
  root: {
    backgroundColor: 'rgba(0, 0, 0, .03)',
    borderBottom: '1px solid rgba(0, 0, 0, .125)',
    marginBottom: -1,
    '&$expanded': {
      minHeight: 48
    }
  },
  content: {
    '&$expanded': {
      margin: '12px 0'
    }
  },
  expanded: {}
})(MuiAccordionSummary);

const AccordionDetails = withStyles({
  root: {
    padding: 0,
    display: 'block'
  }
})(MuiAccordionDetails);

const styles = theme => ({
  root: {
    backgroundColor: '#F7F7F7',
    flexGrow: 1,
    width: '100%',
    [theme.breakpoints.up('sm')]: {
      maxWidth: 375,
      margin: '0 auto'
    }
  },
  pageTitileDiv: {
    padding: '10px 10px',
    textAlign: 'left',
    backgroundColor: '#fff'
  },
  mainPaper: {
    position: 'relative',
    padding: 15
  },
  mainWrapper: {
    padding: '0 15px 10px',
    backgroundColor: '#F7F7F7'
  },
  boxCollapse: {
    backgroundColor: 'transparent'
  },
  textTitleDiv: {
    padding: 0,
    display: 'flex',
    borderBottom: '1px solid #A5A5A5'
  },
  linkRight: {
    marginLeft: 'auto'
  },
  collapseBtn: {
    backgroundColor: 'transparent',
    flexDirection: 'row-reverse',
    padding: 0,
    marginLeft: '-12px',
    borderBottom: 'none'
  },
  textTitle: {
    fontWeight: 'bold',
    fontSize: 20,
    lineHeight: '28px',
    color: 'rgba(0, 0, 0, 0.54)',
    marginLeft: 12
  },
  mainPaper1: {
    position: 'relative',
    backgroundColor: '#2196F3'
  },
  textCurrentReceivedMoneyDiv: {
    textAlign: 'center',
    padding: '20px'
  },
  textCurrentReceivedMoney: {
    color: '#fff',
    fontSize: 16,
    fontWeight: 'bold'
  },
  textMonthHighlight: {
    textAlign: 'left'
  },
  textNum: {
    fontSize: 50,
    fontWeight: 'bold',
    color: '#fff',
    lineHeight: '66px'
  },
  textCurrency: {
    fontSize: 30,
    fontWeight: 'bold',
    lineHeight: '39px',
    color: '#fff'
  },
  textIntendedReceiveMoneyDiv: {
    margin: '10px 0px 0 0px',
    backgroundColor: '#fff',
    padding: '18px 20px',
    // display: 'flex',
    alignItems: 'center'
  },
  textIntendedReceiveMoney: {
    fontSize: 12,
    fontWeight: 'bold',
    lineHeight: '16px',
    color: 'rgba(0, 0, 0, 0.87)'
  },
  textMoneyDiv: {
    marginLeft: 'auto'
  },
  textSmallNum: {
    fontSize: 26,
    fontWeight: 'normal',
    lineHeight: '32px',
    color: 'rgba(0, 0, 0, 0.87)'
  },
  textSmallCurrency: {
    fontSize: 16,
    fontWeight: 'bold',
    lineHeight: '21px',
    color: 'rgba(0, 0, 0, 0.87)'
  },
  currentDateDiv: {
    textAlign: 'right',
    marginTop: 12,
    marginBottom: 15
  },
  currentDate: {
    fontSize: 12,
    fontWeight: 500,
    lineHeight: '16px',
    color: 'rgba(0, 0, 0, 0.54)'
  },
  shopHeader: {
    backgroundColor: '#717171 !important',
    height: 'auto',
    minHeight: 22,
    marginBottom: 10,
    display: 'flex',
    alignItems: 'center'
  },
  titleGroupNameDiv: {
    padding: '5px 12px'
  },
  titleGroupName: {
    fontSize: 10,
    fontWeight: 'normal',
    lineHeight: '13px',
    color: 'rgba(255, 255, 255, 0.87)',
    whiteSpace: 'nowrap'
  },
  textGroupNameDiv: {
    padding: '5px 12px'
  },
  textGroupName: {
    fontSize: 12,
    lineHeight: '16px',
    color: '#fff',
    whiteSpace: 'break-spaces'
  },
  textShopId: {
    fontSize: 10,
    fontWeight: 'normal',
    lineHeight: '13px',
    color: 'rgba(0, 0, 0, 0.54)'
  },
  textShopName: {
    fontWeight: 'bold',
    fontSize: 16,
    lineHeight: '21px',
    color: 'rgba(0, 0, 0, 0.87)',
    margin: '5px 0'
  },
  tableInfo: {
    width: '100%',
    marginBottom: 10
  },
  tableInfoCellHeader: {
    padding: '2px 10px',
    width: '60px',
    borderBottom: '2px solid #ffffff',
    fontSize: '12px',
    fontWeight: 'bold',
    color: '#000000',
    backgroundColor: '#F7F7F7',
    whiteSpace: 'nowrap'
  },
  tableInfoCell: {
    padding: '2px 10px',
    borderBottom: '2px solid transparent',
    fontSize: '12px',
    whiteSpace: 'break-spaces',
    wordBreak: 'break-all'
  },
  buttonDiv: {
    backgroundColor: '#F7F7F7',
    display: 'block',
    borderBottom: 'none',
    textAlign: 'center',
    marginBottom: 10,
    margin: 'auto'
  },
  textExplain: {
    fontSize: 14,
    color: '#000000',
    marginTop: 10,
    fontWeight: 'normal'
  },
  arrowCustom: {
    backgroundColor: '#2196F3',
    color: '#ffffff',
    width: 15,
    height: 15,
    borderRadius: '50%',
    margin: 0
  },
  boxCnt: {
    padding: '10px 0'
  },
  gochiBox: {
    padding: 12,
    borderTop: '1px solid #DBDBDB'
  },
  gochiHeader: {
    padding: '10px',
    color: '#ffffff',
    fontSize: 12,
    textAlign: 'center',
    backgroundColor: '#717171',
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'flex-end',
    position: 'relative',
    marginBottom: 20,
    fontFamily: '"Roboto", "Helvetica", "Arial", sans-serif',

    '&:before': {
      content: '""',
      position: 'absolute',
      left: '50%',
      bottom: '-12px',
      transform: 'translateY(-50%)',
      display: 'inline-block',
      width: 0,
      height: 0,
      borderStyle: 'solid',
      borderWidth: '8px 5px 0 5px',
      borderColor: '#717171 transparent transparent transparent'
    }
  },
  couponNo: {
    margin: '0 20px',
    fontSize: 19,
    fontWeight: 'bold',
    lineHeight: '22px',
    fontFamily: '"Roboto", "Helvetica", "Arial", sans-serif'
  },
  textCompare: {
    display: 'inline-block',
    fontFamily: '"Roboto", "Helvetica", "Arial", sans-serif'
  },
  remainCoupon: {
    backgroundColor: '#FFD0D5',
    color: '#000000',

    '&:before': {
      borderColor: '#FFD0D5 transparent transparent transparent'
    }
  },
  gochiCoupon: {
    backgroundColor: '#fffbd0',
    color: '#000000',

    '&:before': {
      borderColor: '#fffbd0 transparent transparent transparent'
    }
  },
  // tableInfo: {
  //   width: '100%'
  // },
  // tableInfoCellHeader: {
  //   padding: '2px 10px',
  //   width: '90px',
  //   borderBottom: '2px solid #ffffff',
  //   fontSize: '12px',
  //   fontWeight: 'bold',
  //   color: '#000000',
  //   backgroundColor: '#F7F7F7'
  // },
  // tableInfoCell: {
  //   padding: '2px 10px',
  //   borderBottom: '2px solid transparent',
  //   fontSize: '12px'
  // },

  boxMessage: {
    padding: '8px 10px',
    border: '1px solid #DBDBDB',
    borderRadius: 6,
    fontSize: 12,
    color: '#000000',
    marginTop: 15
  },
  messageTtl: {
    marginBottom: 5,
    display: 'flex',
    width: '100%',
    alignItems: 'center'
  },
  iconReply: {
    fontSize: 18,
    display: 'inline-block',
    marginRight: 5
  },
  boxMessageReply: {
    fontSize: 12,
    paddingLeft: 10,
    marginTop: 10,
    whiteSpace: 'pre-line'
  },
  inputRoot: {
    width: '100%'
  },
  inputMessage: {
    borderColor: '#DBDBDB',
    borderRadius: 0,
    padding: '10px 15px',
    height: 70,
    fontSize: 12
  },
  buttonSend: {
    marginLeft: 'auto',
    height: 22,
    fontSize: 12,
    padding: 0
  },
  messageReplyBox: {
    backgroundColor: '#F7F7F7',
    borderRadius: 6,
    padding: '8px 10px',
    whiteSpace: 'pre-line'
  },
  textRedBig: {
    color: '#F50357'
  },
  textRed: {
    color: '#F1226D'
  },
  textId: {
    fontSize: 10,
    color: '#777777',
    display: 'inline-block',
    marginLeft: 5
  },
  modalMobile: {
    maxWidth: 380,
    margin: 'auto',
    padding: '5% 12px 5%'
  },
  btnCenter: {
    padding: 10,
    textAlign: 'center'
  },
  textExplainDate: {
    color: '#ffffff',
    fontSize: 12,
    marginTop: 10,
    textAlign: 'left'
  },
  listNotis: {
    padding: 0
  },
  itemNoti: {
    padding: 10,
    borderBottom: '1px solid #DBDBDB',
    cursor: 'pointer'
  },
  dateText: {
    fontSize: 14,
    fontWeight: 'bold',
    marginBottom: 5
  },
  titleContent: {
    fontSize: 14
  },
  dateStyle: {
    color: 'rgba(0, 0, 0, 0.5)',
    fontSize: 12,
    marginBottom: 5
  },
  titlePost: {
    color: 'rgba(0, 0, 0, 0.87)',
    fontSize: 14
  },
  textContain: {
    padding: '5px 15px 15px 15px',
    backgroundColor: '#ffffff'
  },
  listPosts: {
    padding: 0
  },
  itemPost: {
    backgroundColor: '#ffffff',
    marginBottom: 15,
    padding: 0,
    cursor: 'pointer'
  },
  importantItem: {
    color: '#C2000A',
    backgroundColor: '#FFD5D7',
    cursor: 'pointer'
  },
  importantItemIcon: {
    padding: '8px 0 0 16px'
  },
  gochiChargeHeader: {
    backgroundColor: '#d0dbff'
  },
  noteFirstLoggin: {
    cursor: 'pointer',
    fontSize: '12px',
    fontWeight: 700,
    marginTop: '5px',
    marginBottom: '5px',
    padding: '10px'
  },
  fs20: {
    fontSize: 20
  },
  paymentBalanceDiv: {
    backgroundColor: '#ffffff',
    border: '4px solid #2196F3',
    borderRadius: 2,
    color: '#2196F3',
    fontWeight: 700,
    marginTop: 24,
    padding: '24px 16px',
    textAlign: 'center'
  },
  donateGochiKidInfo: {
    display: 'flex',
    justifyContent: 'space-around'
  },
  donateGochiKidDiv: {
    margin: '10px 30px 0'
  },
  donateGochiKidIcon: {
    width: 9,
    height: 10,
    marginLeft: 5
  }
});

const propTypes = {
  classes: PropTypes.object.isRequired
};

const enhance = compose(
  connect(
    state => ({
      account: state.accounts.account,
      name: state.loginInfo.name
    }),
    dispatch => ({
      actions: bindActionCreators(
        {
          getAccounts,
          getTopPageInfo,
          postShopReply,
          postShashokuShopReply,
          getShops,
          getShopDetail,
          getGochiTipSummary,
          getGochiTipUrl,
          getMenuGenreOption,
          getMenuSituationOption,
          getMenuUserTargetOption,
          getBankList,
          getBankBranchList,
          getFirstLoginAfterReleaseShop,
          putFirstLoginAfterReleaseShop
        },
        dispatch
      )
    })
  ),
  setPropTypes(propTypes),
  withState('shopId', 'setShopId', 0),
  withState('released', 'setReleased', false),
  withState('accountStatusAll', 'setAccountStatusAll', false),
  withState('accountStatusShop', 'setAccountStatusShop', false),
  withState('accountStatusStripe', 'setAccountStatusStripe', false),
  withState('accountStatusIdentity', 'setAccountStatusIdentity', false),
  withState('openShopOpen', 'setOpenShopOpen', false),
  withState('loading', 'updateLoading', false),
  withState('disabled', 'updateDisabled', false),
  withState('openProgress', 'updateOpenProgress', false),
  withState('topInfo', 'setTopInfo', false),
  withState('shopReplyText', 'setShopReplyText', ''),
  withState('messageReply', 'setMessageReply', []),
  withState('shashokuShopReplyText', 'setShashokuShopReplyText', ''),
  withState('shashokuMessageReply', 'setShashokuMessageReply', []),
  withState('groupId', 'setGroupId', 0),
  withState('groupName', 'setGroupName', ''),
  withState('groupDepositManage', 'setGroupDepositManage', ''),
  withState('shopId', 'setShopId', 0),
  withState('shopName', 'setShopName', ''),
  withState('shopNameKana', 'setShopNameKana', ''),
  withState('countryCode', 'setCountryCode', ''),
  withState('zipCode', 'setZipCode', ''),
  withState('prefectureCode', 'setPrefectureCode', 0),
  withState('prefectures', 'setPrefectures', ''),
  withState('city', 'setCity', ''),
  withState('address', 'setAddress', ''),
  withState('address1', 'setAddress1', ''),
  withState('address2', 'setAddress2', ''),
  withState('building', 'setBuilding', ''),
  withState('shopGroupName', 'setShopGroupName', ''),
  withState('shopContactName', 'setShopContactName', ''),
  withState('department', 'setDepartment', ''),
  withState('contactPhone', 'setContactPhone', ''),
  withState('phone', 'setPhone', ''),
  withState('introduction', 'setIntroduction', ''),
  withState('businessHours', 'setBusinessHours', ''),
  withState('holiday', 'setHoliday', ''),
  withState('nearestStation', 'setNearestStation', ''),
  withState('priceRange', 'setPriceRange', ''),
  withState('access', 'setAccess', ''),
  withState('webPage', 'setWebPage', ''),
  withState('tags', 'setTags', []),
  withState('tagStr', 'setTagStr', ''),
  withState('images', 'setImages', []),
  withState('shopAnniversaries', 'setShopAnniversaries', []),
  withState('status', 'setStatus', ''),
  withState('statusStr', 'setStatusStr', ''),
  withState('stealthMode', 'setStealthMode', ''),
  withState('stealthModeStr', 'setStealthModeStr', ''),
  withState('gochiRestriction', 'setGochiRestriction', ''),
  withState('gochiRestrictionStr', 'setGochiRestrictionStr', ''),
  withState('depositManage', 'setDepositManage', 'NONSELF'),
  withState('depositManageStr', 'setDepositManageStr', '入金を自身で管理する'),
  withState('bankName', 'setBankName', ''),
  withState('bankBranchName', 'setBankBranchName', ''),
  withState('bankAccountType', 'setBankAccountType', 'SAVINGS'),
  withState('bankAccountTypeStr', 'setBankAccountTypeStr', '普通預金'),
  withState('bankAccountNumber', 'setBankAccountNumber', ''),
  withState('bankAccountHolder', 'setBankAccountHolder', ''),
  withState('inviteUserId', 'setInviteUserId', 0),
  withState('inviteUserStr', 'setInviteUserStr', ''),
  withState('cognitoUserId', 'setCognitoUserId', ''),
  withState('email', 'setEmail', ''),
  withState('bankSwitchable', 'setBankSwitchable', true),
  withState('createdAt', 'setCreatedAt', ''),
  withState('updatedAt', 'setUpdatedAt', ''),
  withState('rowsPerPage', 'setRowsPerPage', 100),
  withState('order', 'setOrder', 'asc'),
  withState('orderBy', 'setOrderBy', null),
  withState('shopCategoryId', 'setShopCategoryId', 0),
  withState('numberSit', 'setNumberSit', ''),
  withState('smoking', 'setSmoking', ''),
  withState('parking', 'setParking', ''),
  withState('snsFacebook', 'setSnsFacebook', ''),
  withState('snsTwitter', 'setSnsTwitter', ''),
  withState('snsInstagram', 'setSnsInstagram', ''),
  withState('openDetailModal', 'updateOpenDetailModal', false),
  withState('openEditModal', 'updateOpenEditModal', false),
  withState('openEditConfirm', 'updateOpenEditConfirm', false),
  withState('showPhone', 'setShowPhone', 1),
  withState('childShopFlag', 'setChildShopFlag', 0),
  withState('accountStatus', 'setAccountStatus', 1),
  withState('statusShop', 'setStatusShop', 'AVAILABLE'),
  withState('message', 'setMessage', ''),
  withState('paymentGroupType', 'setPaymentGroupType', ''),
  withState('openNotifyPopup', 'setOpenNotifyPopup', false),
  withState('textTitle', 'setTextTitle', ''),
  withState('textMessage', 'setTextMessage', ''),
  withState('sumAmountCurrentMonth', 'setSumAmountCurrentMonth', 0),
  withState('sumAmountLastMonth', 'setSumAmountLastMonth', 0),
  withState('currentMonth', 'setCurrentMonth', null),
  withState('openAdd', 'updateOpenAdd', false),
  withState('openAddConfirm', 'updateOpenAddConfirm', false),
  withState('openDetailRss', 'setOpenDetailRss', false),
  withState('contentRss', 'setContentRss', {}),
  // withState('rssPostItems', 'setRssPostItems', []),
  withState('rssNotiItems', 'setRssNotiItems', []),
  withState('rssVideoItems', 'setRssVideoItems', []),
  withState('rssImportantItems', 'setRssImportantItems', []),
  withState('cashAllowed', 'setCashAllowed', 0),
  withState('allowGapPayment', 'setAllowGapPayment', 0),
  withState('shopDetail', 'setShopDetail', {}),
  withState('isShopCanEditSetting', 'setIsShopCanEditSetting', false),
  withState('resultMessage', 'setResultMessage', ''),
  withState('menuGenre', 'setMenuGenre', []),
  withState('menuSituation', 'setMenuSituation', []),
  withState('menuUserTarget', 'setMenuUserTarget', []),
  withState('bankCode', 'setBankCode', ''),
  withState('bankBranchCode', 'setBankBranchCode', ''),
  withState('listBank', 'setListBank', []),
  withState('listBankBranch', 'setListBankBranch', []),
  withState('openAddChooseUsageType', 'updateOpenAddChooseUsageType', false),
  withState('registrationId', 'setRegistrationId', 'T'),
  withState('groupRegistrationId', 'setGroupRegistrationId', 'T'),
  withState('paymentGroupId', 'setPaymentGroupId', null),
  withState(
    'openPolicyFirstLoginModal',
    'updateOpenPolicyFirstLoginModal',
    false
  ),
  withState('paymentBalance', 'setPaymentBalance', 0),
  withState('sumAmountGochiKidDonate', 'setSumAmountGochiKidDonate', 0),
  withState('sumAmountGochiKidCanUse', 'setSumAmountGochiKidCanUse', 0),
  withHandlers({
    checkSession: props => data => {
      if (data.error === true && data.payload.status === 403) {
        sendLogin(props);
      }
      return data;
    },
    handleRedirect: props => path => {
      props.history.push(path);
    }
  }),
  lifecycle({
    componentDidMount() {
      isAuthenticated(this.props);
      this.props.updateLoading(true);
      this.props.updateOpenProgress(true);
      this.props.actions.getAccounts({ cognitoUserId: '' }).then(data => {
        this.props.checkSession(data);
        if (data.payload.accountStatus != null) {
          this.props.setShopId(data.payload.shopId);
          this.props.setReleased(data.payload.accountStatus.status);
          this.props.setAccountStatusAll(data.payload.accountStatus.all);
          this.props.setAccountStatusShop(data.payload.accountStatus.shop);
          this.props.setAccountStatusStripe(
            data.payload.accountStatus.stripeAccount
          );
          this.props.setAccountStatusIdentity(
            data.payload.accountStatus.identity
          );
          if (data.payload.shopStatus === 'PRE_AVAILABLE') {
            this.props.updateDisabled(false);
          } else {
            this.props.updateDisabled(true);
          }

          this.props.actions
            .getTopPageInfo({ shopId: data.payload.shopId })
            .then(topPageInfo => {
              console.log(topPageInfo);
              if (topPageInfo.type === 'GET_TOPPAGE_SUCCESS') {
                this.props.setTopInfo(topPageInfo.payload);
                this.props.updateLoading(false);
                this.props.updateOpenProgress(false);
                if (
                  sessionStorage.getItem('flagFirstLogginShop') === null ||
                  sessionStorage.getItem('flagFirstLogginShop') === undefined
                ) {
                  sessionStorage.setItem(
                    'flagFirstLogginShop',
                    topPageInfo.payload.firstLogin
                  );
                }
                if (topPageInfo.payload.shop) {
                  this.props.setSumAmountCurrentMonth(
                    topPageInfo.payload.shop.shopStripeFlag === 1
                      ? topPageInfo.payload.shop.sumAmountStripeCurrentMonth
                      : topPageInfo.payload.shop.sumAmountBillCurrentMonth
                  );
                  this.props.setSumAmountLastMonth(
                    topPageInfo.payload.shop.sumAmountBillLastMonth +
                      topPageInfo.payload.shop.sumAmountStripeLastMonth
                  );
                  this.props.setCurrentMonth(
                    topPageInfo.payload.shop.currentMonth
                  );
                  this.props.setPaymentBalance(
                    topPageInfo.payload.shop.paymentBalance || 0
                  );
                  this.props.setSumAmountGochiKidDonate(
                    topPageInfo.payload.shop.sumAmountGochiKidDonate || 0
                  );
                  this.props.setSumAmountGochiKidCanUse(
                    topPageInfo.payload.shop.sumAmountGochiKidCanUse || 0
                  );
                }
              }

              this.props.updateLoading(false);
              this.props.updateOpenProgress(false);
            });
        }
      });

      const parser = new Parser();
      // get noti rss
      parser.parseURL(
        `https://shops.gochimeshi.com/feeds/42755547-51ae-4b47-af16-f50b58d106f2.rss`,
        (err, feed) => {
          if (err) throw err;
          this.props.setRssNotiItems(feed.items);
        }
      );

      // // get post rss
      // parser.parseURL(
      //   `https://shops.gochimeshi.com/feeds/fa6608d1-ee67-4ee1-a563-36842e0302c0.rss`,
      //   (err, feed) => {
      //     if (err) throw err;
      //     this.props.setRssPostItems(feed.items);
      //   }
      // );

      // get video rss
      parser.parseURL(
        `https://shops.gochimeshi.com/feeds/1c2977b2-f950-43f3-8eda-f669f30f3200.rss`,
        (err, feed) => {
          if (err) throw err;
          this.props.setRssVideoItems(feed.items);
        }
      );

      // get important
      parser.parseURL(
        `https://shops.gochimeshi.com/feeds/7872cf17-bbf8-402a-bd7b-727c8b5bb32e.rss`,
        (err, feed) => {
          if (err) throw err;
          this.props.setRssImportantItems(feed.items);
        }
      );

      this.props.actions.getMenuGenreOption().then(data => {
        this.props.checkSession(data);
        this.props.setMenuGenre(data.payload);
      });
      this.props.actions.getMenuSituationOption().then(data => {
        this.props.checkSession(data);
        this.props.setMenuSituation(data.payload);
      });
      this.props.actions.getMenuUserTargetOption().then(data => {
        this.props.checkSession(data);
        this.props.setMenuUserTarget(data.payload);
      });
      this.props.actions.getFirstLoginAfterReleaseShop().then(data => {
        if (data.type === GET_FIRST_LOGIN_AFTER_RELEASE_SUCCESS) {
          if (data.payload.firstLogin !== 0) {
            this.props.updateOpenPolicyFirstLoginModal(true);
          }
        } else {
          this.props.updateOpenPolicyFirstLoginModal(true);
        }
      });
    }
  })
);

const Main = enhance(
  ({
    classes,
    handleRedirect,
    account,
    name,
    openShopOpen,
    setOpenShopOpen,
    updateLoading,
    disabled,
    updateDisabled,
    updateOpenProgress,
    topInfo,
    shopReplyText,
    setShopReplyText,
    messageReply,
    setMessageReply,
    checkSession,
    actions,
    shopId,
    setTopInfo,
    openDetailModal,
    updateOpenDetailModal,
    openEditModal,
    updateOpenEditModal,
    openEditConfirm,
    updateOpenEditConfirm,
    groupId,
    setGroupId,
    groupName,
    setGroupName,
    groupDepositManage,
    setGroupDepositManage,
    setShopId,
    shopName,
    setShopName,
    shopNameKana,
    setShopNameKana,
    countryCode,
    setCountryCode,
    zipCode,
    setZipCode,
    prefectureCode,
    setPrefectureCode,
    prefectures,
    setPrefectures,
    city,
    setCity,
    address1,
    address2,
    setAddress1,
    setAddress2,
    building,
    setBuilding,
    shopGroupName,
    setShopGroupName,
    shopContactName,
    setShopContactName,
    department,
    setDepartment,
    contactPhone,
    setContactPhone,
    phone,
    setPhone,
    introduction,
    setIntroduction,
    businessHours,
    setBusinessHours,
    holiday,
    setHoliday,
    nearestStation,
    setNearestStation,
    priceRange,
    setPriceRange,
    access,
    setAccess,
    webPage,
    setWebPage,
    tags,
    setTags,
    tagStr,
    setTagStr,
    images,
    setImages,
    shopAnniversaries,
    setShopAnniversaries,
    status,
    setStatus,
    statusStr,
    setStatusStr,
    stealthMode,
    setStealthMode,
    stealthModeStr,
    setStealthModeStr,
    gochiRestriction,
    setGochiRestriction,
    gochiRestrictionStr,
    setGochiRestrictionStr,
    depositManage,
    setDepositManage,
    depositManageStr,
    setDepositManageStr,
    bankName,
    setBankName,
    bankBranchName,
    setBankBranchName,
    bankAccountType,
    setBankAccountType,
    bankAccountTypeStr,
    setBankAccountTypeStr,
    bankAccountNumber,
    setBankAccountNumber,
    bankAccountHolder,
    setBankAccountHolder,
    inviteUserId,
    setInviteUserId,
    inviteUserStr,
    setInviteUserStr,
    cognitoUserId,
    setCognitoUserId,
    email,
    setEmail,
    bankSwitchable,
    setBankSwitchable,
    createdAt,
    setCreatedAt,
    updatedAt,
    setUpdatedAt,
    // order,
    // orderBy,
    // handleChangeRowsPerPage,
    // handleRequestSort,
    shopCategories,
    shopCategoryId,
    setShopCategoryId,
    numberSit,
    setNumberSit,
    smoking,
    setSmoking,
    parking,
    setParking,
    snsFacebook,
    setSnsFacebook,
    setSnsTwitter,
    snsTwitter,
    setSnsInstagram,
    snsInstagram,
    showPhone,
    setShowPhone,
    childShopFlag,
    setChildShopFlag,
    accountStatus,
    setAccountStatus,
    // statusShop,
    // setStatusShop,
    // message,
    // setMessage,
    paymentGroupType,
    setPaymentGroupType,
    textTitle,
    setTextTitle,
    textMessage,
    setTextMessage,
    openNotifyPopup,
    setOpenNotifyPopup,
    sumAmountCurrentMonth,
    sumAmountLastMonth,
    openProgress,
    loading,
    openAdd,
    updateOpenAdd,
    openAddConfirm,
    updateOpenAddConfirm,
    openDetailRss,
    setOpenDetailRss,
    contentRss,
    setContentRss,
    rssNotiItems,
    // rssPostItems,
    rssVideoItems,
    rssImportantItems,
    cashAllowed,
    setCashAllowed,
    shopDetail,
    setShopDetail,
    isShopCanEditSetting,
    setIsShopCanEditSetting,
    shashokuShopReplyText,
    setShashokuShopReplyText,
    shashokuMessageReply,
    setShashokuMessageReply,
    resultMessage,
    menuGenre,
    menuSituation,
    menuUserTarget,
    bankCode,
    setBankCode,
    bankBranchCode,
    setBankBranchCode,
    listBank,
    setListBank,
    listBankBranch,
    setListBankBranch,
    openAddChooseUsageType,
    updateOpenAddChooseUsageType,
    registrationId,
    setRegistrationId,
    groupRegistrationId,
    setGroupRegistrationId,
    paymentGroupId,
    setPaymentGroupId,
    openPolicyFirstLoginModal,
    updateOpenPolicyFirstLoginModal,
    paymentBalance,
    sumAmountGochiKidDonate,
    sumAmountGochiKidCanUse,
    allowGapPayment,
    setAllowGapPayment
  }) => {
    const isShop = typeof account !== 'undefined' && account.role === 'SHOP';
    const isFukuoka =
      typeof account !== 'undefined' && account.fukuokaFlag === 1;
    const isNaha = typeof account !== 'undefined' && account.nahaFlag === 1;
    const educateSystem =
      typeof account !== 'undefined' && account.educateSystem;
    const isChildShop =
      typeof account !== 'undefined' &&
      account.role === 'SHOP' &&
      (account.belongToChildGroups !== 'undefined' &&
        account.belongToChildGroups.length > 0);

    const isChildShopOnly =
      typeof account !== 'undefined' &&
      account.role === 'SHOP' &&
      ((account.belongToChildGroups !== 'undefined' &&
        account.belongToChildGroups.length > 0) ||
        account.childShopFlag === 1);
    const isGroup = typeof account !== 'undefined' && account.role === 'GROUP';
    const isSecretariat =
      typeof account !== 'undefined' && account.role === 'SECRETARIAT';
    const isDeveloper =
      typeof account !== 'undefined' && account.role === 'DEVELOPER';
    const isReleased =
      account && account.accountStatus && account.accountStatus.status === true;
    const roles = {
      isShop,
      isGroup,
      isSecretariat,
      isDeveloper,
      isChildShop,
      isChildShopOnly
    };
    const showShopOpenAction = () => {
      updateLoading(true);
      setOpenShopOpen(true);
    };

    const progress = {
      updateLoading,
      updateOpenProgress
    };

    const detail = {
      groupId,
      groupName,
      groupDepositManage,
      shopId,
      shopName,
      shopNameKana,
      countryCode,
      zipCode,
      prefectureCode,
      prefectures,
      city,
      address1,
      address2,
      building,
      shopGroupName,
      shopContactName,
      department,
      contactPhone,
      phone,
      businessHours,
      introduction,
      holiday,
      nearestStation,
      priceRange,
      access,
      webPage,
      tags,
      tagStr,
      images,
      shopAnniversaries,
      status,
      statusStr,
      stealthMode,
      stealthModeStr,
      gochiRestriction,
      gochiRestrictionStr,
      depositManage,
      depositManageStr,
      bankName,
      bankBranchName,
      bankAccountType,
      bankAccountTypeStr,
      bankAccountNumber,
      bankAccountHolder,
      inviteUserId,
      inviteUserStr,
      cognitoUserId,
      email,
      bankSwitchable,
      createdAt,
      updatedAt,
      shopCategories,
      shopCategoryId,
      numberSit,
      smoking,
      parking,
      snsFacebook,
      snsTwitter,
      snsInstagram,
      showPhone,
      childShopFlag,
      accountStatus,
      paymentGroupType,
      cashAllowed,
      isShopCanEditSetting,
      shopDetail,
      bankCode,
      bankBranchCode,
      registrationId,
      groupRegistrationId,
      paymentGroupId,
      allowGapPayment
    };

    const getShop = async id => {
      await actions.getShopDetail(id).then(detailData => {
        checkSession(detailData);
        setGroupId(detailData.payload.groupId);
        setGroupName(detailData.payload.groupName);
        setGroupDepositManage(detailData.payload.groupDepositManage);
        setShopId(detailData.payload.shopId);
        setShopName(detailData.payload.shopName);
        setShopNameKana(detailData.payload.shopNameKana);
        setCountryCode(detailData.payload.countryCode);
        setZipCode(detailData.payload.zipCode);
        setPrefectureCode(detailData.payload.prefectureCode);
        setPrefectures(detailData.payload.prefectures);
        setCity(detailData.payload.city);
        // setAddress(detailData.payload.address);
        setAddress1(detailData.payload.address1);
        setAddress2(detailData.payload.address2);
        setBuilding(detailData.payload.building);
        setShopGroupName(detailData.payload.shopGroupName);
        setShopContactName(detailData.payload.shopContactName);
        setDepartment(detailData.payload.department);
        setContactPhone(detailData.payload.contactPhone);
        setPhone(detailData.payload.phone);
        setIntroduction(detailData.payload.introduction);
        setBusinessHours(detailData.payload.businessHours);
        setHoliday(detailData.payload.holiday);
        setNearestStation(detailData.payload.nearestStation);
        setPriceRange(detailData.payload.priceRange);
        setAccess(detailData.payload.access);
        setWebPage(detailData.payload.webPage);
        setShopCategoryId(detailData.payload.shopCategoryId);
        setNumberSit(detailData.payload.numberSit);
        setSmoking(detailData.payload.smoking);
        setParking(detailData.payload.parking);
        setSnsFacebook(detailData.payload.snsFacebook);
        setSnsTwitter(detailData.payload.snsTwitter);
        setSnsInstagram(detailData.payload.snsInstagram);
        setShowPhone(detailData.payload.showPhone);
        setChildShopFlag(detailData.payload.childShopFlag);
        setAccountStatus(detailData.payload.accountStatus);
        setPaymentGroupType(detailData.payload.paymentGroupType);
        setCashAllowed(detailData.payload.cashAllowed);
        setAllowGapPayment(detailData.payload.allowGapPayment);
        setShopDetail(detailData.payload.shopDetail);
        setIsShopCanEditSetting(detailData.payload.isShopCanEditSetting);
        if (
          typeof detailData.payload.tags !== 'undefined' &&
          detailData.payload.tags !== null
        ) {
          setTags(detailData.payload.tags);
          setTagStr(
            detailData.payload.tags
              .map(tag => {
                return `${tag.tagName}`;
              })
              .join(' ')
          );
        }
        if (
          typeof detailData.payload.images !== 'undefined' &&
          detailData.payload.images !== null
        ) {
          setImages(detailData.payload.images);
        }
        if (
          typeof detailData.payload.shopAnniversaries !== 'undefined' &&
          detailData.payload.shopAnniversaries !== null
        ) {
          setShopAnniversaries(detailData.payload.shopAnniversaries);
        }
        setStatus(detailData.payload.status);
        setStatusStr(detailData.payload.statusStr);
        setStealthMode(detailData.payload.stealthMode);
        setStealthModeStr(detailData.payload.stealthModeStr);
        setGochiRestriction(detailData.payload.gochiRestriction);
        setGochiRestrictionStr(detailData.payload.gochiRestrictionStr);
        setDepositManage(detailData.payload.depositManage);
        setDepositManageStr(detailData.payload.depositManageStr);
        if (
          typeof detailData.payload.bankAccount !== 'undefined' &&
          detailData.payload.bankAccount !== null
        ) {
          setBankName(detailData.payload.bankAccount.bankName);
          setBankBranchName(detailData.payload.bankAccount.bankBranchName);
          setBankAccountType(detailData.payload.bankAccount.bankAccountType);
          setBankAccountTypeStr(
            detailData.payload.bankAccount.bankAccountTypeStr
          );
          setBankAccountNumber(
            detailData.payload.bankAccount.bankAccountNumber
          );
          setBankAccountHolder(
            detailData.payload.bankAccount.bankAccountHolder
          );
        }
        setInviteUserId(detailData.payload.inviteUserId);
        setInviteUserStr(detailData.payload.inviteUserStr);
        setCognitoUserId(detailData.payload.cognitoUserId);
        setEmail(detailData.payload.email);
        setBankSwitchable(detailData.payload.bankSwitchable);
        setCreatedAt(detailData.payload.createdAt);
        setUpdatedAt(detailData.payload.updatedAt);
        setBankCode(detailData.payload.bankAccount.bankCode);
        setBankBranchCode(detailData.payload.bankAccount.bankBranchCode);
        setRegistrationId(detailData.payload.registrationId);
        setGroupRegistrationId(detailData.payload.groupRegistrationId);
        setPaymentGroupId(detailData.payload.paymentGroupId);
      });
    };

    const detailOpenAction = () => {
      progress.updateLoading(true);
      progress.updateOpenProgress(true);
      getShop(topInfo.shop.shopId)
        .then(() => {
          progress.updateOpenProgress(false);
          progress.updateLoading(false);
          updateOpenDetailModal(true);
        })
        .catch(error => {
          console.log(error);
          progress.updateOpenProgress(false);
          progress.updateLoading(false);
        });
    };
    const editOpenAction = async () => {
      progress.updateLoading(true);
      progress.updateOpenProgress(true);
      const bankResponse = await actions
        .getBankList()
        .then(data => checkSession(data));
      if (bankResponse.type === GET_BANK_LIST_SUCCESS) {
        setListBank(bankResponse.payload);
      } else {
        setListBank([]);
      }
      const bankBranchResponse = await actions
        .getBankBranchList()
        .then(data => checkSession(data));
      if (bankBranchResponse.type === GET_BANK_BRANCH_LIST_SUCCESS) {
        setListBankBranch(bankBranchResponse.payload);
      } else {
        setListBankBranch([]);
      }
      await getShop(account.shopId)
        .then(() => {
          progress.updateOpenProgress(false);
          progress.updateLoading(false);
          updateOpenEditModal(true);
        })
        .catch(() => {
          progress.updateOpenProgress(false);
          progress.updateLoading(false);
        });
    };

    // check if is account shop
    if (!(isShop && isReleased)) {
      handleRedirect('/shops');
    }

    const openDetailPayment = () => {
      handleRedirect('/info_payments_shop');
    };

    const openNotificationPage = () => {
      handleRedirect('/notifications_shop');
    };

    // const openNewsPage = () => {
    //   handleRedirect('/posts_shop');
    // };

    const openVideoPage = () => {
      handleRedirect('/video_shop');
    };

    const openGochisPage = () => {
      handleRedirect('/gochis_shop');
    };

    const openShopPage = () => {
      handleRedirect('/shops_shop');
    };

    const openMenusPage = () => {
      handleRedirect('/gochi_menus_shop');
    };

    const shopReplyMessage = async gochiBillId => {
      updateOpenProgress(true);
      updateLoading(true);
      const params = {
        gochiBillId,
        message: messageReply[gochiBillId]
      };
      const tempReply = { ...shopReplyText };
      await actions.postShopReply(params).then(data => {
        checkSession(data);
        updateOpenProgress(false);
        updateLoading(false);

        if (data.type === 'SHOP_REPLY_SUCCESS') {
          setMessageReply({});

          tempReply[gochiBillId] = data.payload.shopReplyMessage;

          setShopReplyText(tempReply);
          setTextTitle('メール送信完了');
          setTextMessage('感謝のメッセージを送りました。');
          setOpenNotifyPopup(true);
        } else {
          setTextTitle('メール送信エラー');
          setTextMessage(
            'ユーザ様の入力したメールアドレスが間違っていますので、感謝のメッセージが送れません。ご了承ください。'
          );
          setOpenNotifyPopup(true);
        }
      });
      updateOpenProgress(false);
      updateLoading(false);
    };
    const tempObj = {};
    const onChangeReplyMess = (message, gochiBillId) => {
      tempObj[gochiBillId] = message;
      setMessageReply(tempObj);
    };

    const shopShashokuReplyMessage = async shashokuTicketShopMessageId => {
      updateOpenProgress(true);
      updateLoading(true);
      const params = {
        shashokuTicketShopMessageId,
        shopReplyMessage: shashokuMessageReply[shashokuTicketShopMessageId]
      };
      const tempReply = { ...shashokuShopReplyText };
      console.log('tempReply', tempReply);
      console.log('params', params);
      await actions.postShashokuShopReply(params).then(data => {
        checkSession(data);
        updateOpenProgress(false);
        updateLoading(false);

        if (data.type === 'SHASHOKU_SHOP_REPLY_SUCCESS') {
          setShashokuMessageReply({});

          tempReply[shashokuTicketShopMessageId] =
            shashokuMessageReply[shashokuTicketShopMessageId];

          console.log('tempReply', tempReply);

          setShashokuShopReplyText(tempReply);
          setTextTitle('メール送信完了');
          setTextMessage('感謝のメッセージを送りました。');
          setOpenNotifyPopup(true);
        } else {
          setTextTitle('メール送信エラー');
          setTextMessage(
            'ユーザ様の入力したメールアドレスが間違っていますので、感謝のメッセージが送れません。ご了承ください。'
          );
          setOpenNotifyPopup(true);
        }
      });
      updateOpenProgress(false);
      updateLoading(false);
    };
    const tempObj1 = {};
    const onChangeShashokuReplyMess = (
      message,
      shashokuTicketShopMessageId
    ) => {
      tempObj1[shashokuTicketShopMessageId] = message;
      setShashokuMessageReply(tempObj1);
    };

    const handleChangePage = () => {
      setTimeout(() => {
        updateLoading(true);
        updateOpenProgress(true);
        actions.getTopPageInfo({ shopId }).then(topPageInfo => {
          setTopInfo(topPageInfo.payload);
          updateLoading(false);
          updateOpenProgress(false);
        });
      }, 100);
    };

    const progressOkAction = () => {
      updateOpenProgress(false);
    };

    const currencyFormat = num => {
      if (!num) {
        return 0;
      }
      return num.toFixed(0).replace(/(\d)(?=(\d{3})+(?!\d))/g, '$1,');
    };

    // const monthFormat = timeStr => {
    //   const date = new Date(timeStr);
    //   return date.getMonth() + 1;
    // };

    const dateFormat = timeStr => {
      const date = new Date(timeStr);
      let day = date.getDate();
      let month = date.getMonth() + 1;
      if (month < 10) {
        month = `0${month}`;
      }
      if (day < 10) {
        day = `0${day}`;
      }
      const year = date.getFullYear();
      return `${year}/${month}/${day}`;
    };

    const addAction = async () => {
      updateLoading(true);
      updateOpenProgress(true);
      const shopData = await actions
        .getShops()
        .then(data => checkSession(data));
      if (shopData.type === 'GET_SHOPS_SUCCESS') {
        if (!shopId) {
          const initialShopId = isShop ? shopData.payload.shops[0].shopId : 0;
          setShopId(initialShopId);
        }
        updateOpenProgress(false);
        updateLoading(false);
        if (isFukuoka) {
          updateOpenAdd(true);
        } else {
          updateOpenAddChooseUsageType(true);
        }
      } else {
        updateOpenProgress(false);
        updateLoading(false);
      }
    };

    const actionOpenDetail = params => {
      setContentRss(params);
      setOpenDetailRss(true);
    };

    let countGochi = 0;

    const importantRssParams = () => {
      const params = {
        title: rssImportantItems[0].title,
        content: rssImportantItems[0].content,
        pubDate: dateFormat(rssImportantItems[0].pubDate)
      };
      return params;
    };

    const handleClickAccessPolicy = () => {
      updateOpenPolicyFirstLoginModal(false);
      actions
        .putFirstLoginAfterReleaseShop({ firstLogin: 0 })
        .then(data => checkSession(data));
    };

    const goToDonateGochiKid = () => {
      handleRedirect('/donations_shop');
    };

    return (
      <>
        <div className={classes.root}>
          <Header name={name} />
          {!isFukuoka &&
            parseInt(sessionStorage.getItem('flagFirstLogginShop'), 10) ===
              1 && (
              <div
                className={classes.noteFirstLoggin}
                onClick={openShopPage}
                aria-hidden="true"
              >
                店舗情報を充実させると、ユーザー様によりアピールできます⇨「編集」より、「その他(任意)」の項目をご登録ください。
              </div>
            )}
          {rssImportantItems && rssImportantItems.length > 0 && (
            <Box>
              <Paper className={classes.mainPaperWhite} elevation={1}>
                <List
                  component="nav"
                  className={(classes.listNotis, classes.importantItem)}
                  aria-label="contacts"
                >
                  <Grid
                    container
                    className={classes.importantItem}
                    onClick={() => actionOpenDetail(importantRssParams())}
                  >
                    <Grid item xs={1} className={classes.importantItemIcon}>
                      <ErrorIcon />
                    </Grid>
                    <Grid item xs={11}>
                      <ListItem>
                        <div>
                          <div className={classes.dateText}>重要なお知らせ</div>
                          <div className={classes.titleContent}>
                            {rssImportantItems[0].title}
                          </div>
                        </div>
                      </ListItem>
                    </Grid>
                  </Grid>
                </List>
              </Paper>
            </Box>
          )}

          <MenuBox account={account} />
          {!disabled && (
            <div className={classes.pageTitileDiv}>
              <ShopOpenButton
                onClickAction={showShopOpenAction}
                disabled={disabled}
              />
              <Typography
                variant="h6"
                color="textPrimary"
                className={classes.textExplain}
              >
                「開店する」ボタンをタップすると、確認項目が表示されます。その項目にチェックすると開店することができます。
              </Typography>
            </div>
          )}

          {!!account.fukuokaFlag &&
            educateSystem &&
            educateSystem !== nameSystem.suita &&
            educateSystem !== nameSystem.nishiwaki && (
              <div className={classes.pageTitileDiv}>
                <ShopInvoiceButton
                  onClickAction={() => handleRedirect('/invoice_shop')}
                  isFukuoka={isFukuoka}
                />
              </div>
            )}

          <div className={classes.mainWrapper}>
            <Accordion defaultExpanded className={classes.boxCollapse}>
              <div className={classes.textTitleDiv}>
                <AccordionSummary
                  expandIcon={
                    <ExpandMoreIcon className={classes.arrowCustom} />
                  }
                  aria-controls="statistic-pannel"
                  id="statistic-pannel"
                  className={classes.collapseBtn}
                >
                  {/* <Typography className={classes.heading}>
                    運営からのお知らせ
                  </Typography> */}
                  <Typography className={classes.textTitle}>
                    {`${isFukuoka ? '精算' : '入金'}情報管理`}
                  </Typography>
                </AccordionSummary>

                <Button
                  onClick={openDetailPayment}
                  color="primary"
                  className={classes.linkRight}
                >
                  全て見る
                </Button>
              </div>

              <AccordionDetails>
                <Paper className={classes.mainPaper1}>
                  <div className={classes.textCurrentReceivedMoneyDiv}>
                    <div
                      className={isFukuoka ? classes.textMonthHighlight : ''}
                    >
                      <span
                        className={classNames(
                          classes.textCurrentReceivedMoney,
                          !isFukuoka ? classes.fs20 : ''
                        )}
                      >
                        {topInfo.shop && topInfo.shop.currentMonthStr}
                        {isFukuoka ? '月の精算金額(※1)' : '月の入金金額'}
                        {/* {monthFormat(topInfo.shop.lastMonth)} */}
                      </span>
                    </div>
                    <Text className={classes.textNum}>
                      {currencyFormat(sumAmountLastMonth)}
                    </Text>
                    <Text className={classes.textCurrency}> 円</Text>
                    {isFukuoka && (
                      <>
                        <div className={classes.textIntendedReceiveMoneyDiv}>
                          <div className={classes.textIntendedReceiveMoney}>
                            現時点での
                            {topInfo.shop && topInfo.shop.nextMonthStr}
                            {isFukuoka
                              ? '月精算予定金額(※2)'
                              : '月入金予定金額(※)'}
                          </div>
                          <div className={classes.textMoneyDiv}>
                            <span className={classes.textSmallNum}>
                              {currencyFormat(sumAmountCurrentMonth)}
                            </span>
                            <span className={classes.textSmallCurrency}>
                              {' '}
                              円
                            </span>
                          </div>
                        </div>

                        <div className={classes.textExplainDate}>
                          {isFukuoka ? (
                            <>
                              ※1
                              毎月9営業日までは前月末の振込金額を表示します。10営業日からは今月末の振込予定金額を表示します。
                              <br />
                              <br />
                              ※2
                              毎月9営業日までは今月末の振込予定金額を表示します。10営業日からは翌月末の振込予定金額を表示します。
                            </>
                          ) : (
                            <>
                              ※入金予定金額は、当該月の現在までの売上げが表示されています。
                              <br />
                              ※プレミアム金額については、月末に別途締め作業を行い送金いたします。
                              <br />
                              ※プレミアム金額については、キャンペーンによって入金タイミングが異なります。
                              <br />
                              ※正確な銀行への入金については、当該月末〆、翌5営業日以内に入金、10営業日以内に表示されます。
                              <br />
                              ※詳しくはGOCHIプラットフォーム管理システムの「入金情報管理」にて確認ください。
                              <br />
                            </>
                          )}
                        </div>
                      </>
                    )}
                  </div>
                </Paper>
                {!isFukuoka && (
                  <div className={classes.paymentBalanceDiv}>
                    <div style={{ fontSize: 18 }}>現在のお支払い残額</div>
                    <div style={{ marginTop: 8 }}>
                      <span style={{ fontSize: 48 }}>
                        {paymentBalance.toLocaleString()}
                      </span>
                      <span style={{ fontSize: 32 }}>円</span>
                    </div>
                  </div>
                )}
                <div className={classes.currentDateDiv}>
                  {!isFukuoka && (
                    <span className={classes.currentDate}>
                      {dateFormat(new Date())}
                      {` `}
                      現在
                    </span>
                  )}
                </div>
                {!isFukuoka && (
                  <div className={classes.paymentBalanceDiv}>
                    <div style={{ fontSize: 18 }}>こどもごちめし支援額</div>
                    <div className={classes.donateGochiKidInfo}>
                      <div>
                        <div style={{ fontSize: 18 }}>支援残額</div>
                        <div style={{ marginTop: 5 }}>
                          <span style={{ fontSize: 20 }}>
                            {sumAmountGochiKidCanUse.toLocaleString()}
                          </span>
                          <span style={{ fontSize: 12 }}>円</span>
                        </div>
                      </div>

                      <div>
                        <div style={{ fontSize: 18 }}>支援額累計</div>
                        <div style={{ marginTop: 5 }}>
                          <span style={{ fontSize: 20 }}>
                            {sumAmountGochiKidDonate.toLocaleString()}
                          </span>
                          <span style={{ fontSize: 12 }}>円</span>
                        </div>
                      </div>
                    </div>
                    <div className={classes.donateGochiKidDiv}>
                      <Button
                        variant="contained"
                        color="primary"
                        style={{ width: '100%' }}
                        onClick={() => goToDonateGochiKid()}
                      >
                        <span>詳細</span>
                        <ArrowForwardIosIcon
                          className={classes.donateGochiKidIcon}
                        />
                      </Button>
                    </div>
                  </div>
                )}
              </AccordionDetails>
            </Accordion>
          </div>

          {!isFukuoka && (
            <div className={classes.mainWrapper}>
              <Accordion defaultExpanded className={classes.boxCollapse}>
                <div className={classes.textTitleDiv}>
                  <AccordionSummary
                    expandIcon={
                      <ExpandMoreIcon className={classes.arrowCustom} />
                    }
                    aria-controls="notification-pannel"
                    id="notification-pannel"
                    className={classes.collapseBtn}
                  >
                    <Typography className={classes.textTitle}>
                      運営からのお知らせ
                    </Typography>
                  </AccordionSummary>

                  <Button
                    onClick={openNotificationPage}
                    color="primary"
                    className={classes.linkRight}
                  >
                    全て見る
                  </Button>
                </div>

                <AccordionDetails>
                  <Box className={classes.boxCnt}>
                    {rssImportantItems && rssImportantItems.length > 0 && (
                      <Paper className={classes.mainPaperWhite} elevation={1}>
                        <List
                          component="nav"
                          className={(classes.listNotis, classes.importantItem)}
                          aria-label="contacts"
                        >
                          <Grid
                            container
                            className={classes.importantItem}
                            onClick={() =>
                              actionOpenDetail(importantRssParams())
                            }
                          >
                            <Grid
                              item
                              xs={1}
                              className={classes.importantItemIcon}
                            >
                              <ErrorIcon />
                            </Grid>
                            <Grid item xs={11}>
                              <ListItem>
                                <div>
                                  <div className={classes.dateText}>
                                    重要なお知らせ
                                  </div>
                                  <div className={classes.titleContent}>
                                    {rssImportantItems[0].title}
                                  </div>
                                </div>
                              </ListItem>
                            </Grid>
                          </Grid>
                        </List>
                      </Paper>
                    )}
                    {rssNotiItems && (
                      <Paper className={classes.mainPaperWhite} elevation={1}>
                        <List
                          component="nav"
                          className={classes.listNotis}
                          aria-label="contacts"
                        >
                          {rssNotiItems.map((item, index) => {
                            const params = {
                              title: item.title,
                              content: item.content,
                              pubDate: dateFormat(item.pubDate)
                            };
                            return (
                              <>
                                {index < 3 && (
                                  <ListItem
                                    className={classes.itemNoti}
                                    onClick={() => actionOpenDetail(params)}
                                    // eslint-disable-next-line react/no-array-index-key
                                    key={`noti${index}`}
                                  >
                                    <div>
                                      <div className={classes.dateText}>
                                        {dateFormat(item.pubDate)}
                                      </div>
                                      <div className={classes.titleContent}>
                                        {item.title}
                                      </div>
                                    </div>
                                  </ListItem>
                                )}
                              </>
                            );
                          })}
                        </List>
                      </Paper>
                    )}
                  </Box>
                </AccordionDetails>
              </Accordion>
            </div>
          )}

          {/* Hide because not update - 08/09/2022 */}
          {/* <div className={classes.mainWrapper}>
            <Accordion defaultExpanded className={classes.boxCollapse}>
              <div className={classes.textTitleDiv}>
                <AccordionSummary
                  expandIcon={
                    <ExpandMoreIcon className={classes.arrowCustom} />
                  }
                  aria-controls="news-pannel"
                  id="news-pannel"
                  className={classes.collapseBtn}
                >
                  <Typography className={classes.textTitle}>
                    新着記事
                  </Typography>
                </AccordionSummary>

                <Button
                  onClick={openNewsPage}
                  color="primary"
                  className={classes.linkRight}
                >
                  全て見る
                </Button>
              </div>

              <AccordionDetails>
                <Box className={classes.boxCnt}>
                  {rssPostItems && (
                    <List
                      component="nav"
                      className={classes.listPosts}
                      aria-label="contacts"
                    >
                      {rssPostItems.map((item, index) => {
                        const params = {
                          title: item.title,
                          content: item.content,
                          pubDate: dateFormat(item.pubDate)
                        };
                        return (
                          <>
                            {index < 3 && (
                              <ListItem
                                className={classes.itemPost}
                                onClick={() => actionOpenDetail(params)}
                                // eslint-disable-next-line react/no-array-index-key
                                key={index}
                              >
                                <div>
                                  <img
                                    className={classes.imageFig}
                                    src={item.enclosure && item.enclosure.url}
                                    alt={
                                      item.enclosure && item.enclosure.caption
                                    }
                                    width="100%"
                                  />
                                  <div className={classes.textContain}>
                                    <div className={classes.dateStyle}>
                                      {dateFormat(item.pubDate)}
                                    </div>
                                    <div className={classes.titlePost}>
                                      {item.title}
                                    </div>
                                  </div>
                                </div>
                              </ListItem>
                            )}
                          </>
                        );
                      })}
                    </List>
                  )}
                </Box>
              </AccordionDetails>
            </Accordion>
          </div> */}

          {!isFukuoka && (
            <>
              {' '}
              <div className={classes.mainWrapper}>
                <Accordion defaultExpanded className={classes.boxCollapse}>
                  <div className={classes.textTitleDiv}>
                    <AccordionSummary
                      expandIcon={
                        <ExpandMoreIcon className={classes.arrowCustom} />
                      }
                      aria-controls="video-pannel"
                      id="video-pannel"
                      className={classes.collapseBtn}
                    >
                      <Typography className={classes.textTitle}>
                        ごちめしの使い方
                      </Typography>
                    </AccordionSummary>

                    <Button
                      onClick={openVideoPage}
                      color="primary"
                      className={classes.linkRight}
                    >
                      全て見る
                    </Button>
                  </div>

                  <AccordionDetails>
                    <Box className={classes.boxCnt}>
                      {rssVideoItems && rssVideoItems[0] && (
                        <>
                          <h4 className={classes.titleRss}>
                            {rssVideoItems[0].title}
                          </h4>
                          <div className={classes.frameVideo}>
                            {renderHTML(rssVideoItems[0].content)}
                          </div>
                        </>
                      )}
                    </Box>
                  </AccordionDetails>
                </Accordion>
              </div>
              <div className={classes.mainWrapper}>
                <Accordion defaultExpanded className={classes.boxCollapse}>
                  <div className={classes.textTitleDiv}>
                    <AccordionSummary
                      expandIcon={
                        <ExpandMoreIcon className={classes.arrowCustom} />
                      }
                      aria-controls="gochis-pannel"
                      id="gochis-pannel"
                      className={classes.collapseBtn}
                    >
                      <Typography className={classes.textTitle}>
                        ごち情報
                      </Typography>
                    </AccordionSummary>

                    <Button
                      onClick={openGochisPage}
                      color="primary"
                      className={classes.linkRight}
                    >
                      全て見る
                    </Button>
                  </div>

                  <AccordionDetails>
                    <Box className={classes.boxCnt}>
                      <Paper>
                        <div className="select-block-body m-0">
                          <div className="lst-friends h-100">
                            {topInfo.gochis &&
                              topInfo.gochis.map(gochi => {
                                // const key = `${gochi.gochiBillId}`;
                                const key =
                                  gochi.sourceTable === 'GOCHI'
                                    ? `${gochi.gochiBillId}-${
                                        gochi.sourceTable
                                      }`
                                    : `${gochi.shashokuTicketId}-${
                                        gochi.sourceTable
                                      }`;
                                if (gochi.shopId !== null) {
                                  countGochi += 1;
                                }
                                return (
                                  <>
                                    {countGochi <= 3 && (
                                      <>
                                        {gochi.sourceTable === 'SHASHOKU' && (
                                          <div
                                            className={classes.gochiBox}
                                            key={key}
                                          >
                                            <div
                                              className={classNames(
                                                classes.remainCoupon,
                                                classes.gochiHeader
                                              )}
                                            >
                                              <span>
                                                <b>社食チケット利用状況</b>
                                              </span>
                                            </div>

                                            <Table>
                                              <TableBody
                                                className={classes.tableInfo}
                                              >
                                                <TableRow
                                                  className={
                                                    classes.tableInfoRow
                                                  }
                                                >
                                                  <TableCell
                                                    className={
                                                      classes.tableInfoCellHeader
                                                    }
                                                  >
                                                    利用日
                                                  </TableCell>
                                                  <TableCell
                                                    className={
                                                      classes.tableInfoCell
                                                    }
                                                  >
                                                    {gochi.useDate}
                                                  </TableCell>
                                                </TableRow>
                                                <TableRow>
                                                  <TableCell
                                                    className={
                                                      classes.tableInfoCellHeader
                                                    }
                                                  >
                                                    法人名
                                                  </TableCell>
                                                  <TableCell
                                                    className={
                                                      classes.tableInfoCell
                                                    }
                                                  >
                                                    {gochi.companyName ||
                                                      gochi.connectSystemName}
                                                  </TableCell>
                                                </TableRow>
                                                {(isFukuoka || isNaha) && (
                                                  <TableRow>
                                                    <TableCell
                                                      className={
                                                        classes.tableInfoCellHeader
                                                      }
                                                    >
                                                      利用者名
                                                    </TableCell>
                                                    <TableCell
                                                      className={
                                                        classes.tableInfoCell
                                                      }
                                                    >
                                                      {gochi.shashokuUserName}
                                                    </TableCell>
                                                  </TableRow>
                                                )}
                                                <TableRow>
                                                  <TableCell
                                                    className={
                                                      classes.tableInfoCellHeader
                                                    }
                                                  >
                                                    メニュー名
                                                  </TableCell>
                                                  <TableCell
                                                    className={
                                                      classes.tableInfoCell
                                                    }
                                                  >
                                                    {gochi.menuName}
                                                  </TableCell>
                                                </TableRow>
                                                <TableRow>
                                                  <TableCell
                                                    className={
                                                      classes.tableInfoCellHeader
                                                    }
                                                  >
                                                    使用時の店舗振込額
                                                  </TableCell>
                                                  <TableCell
                                                    className={
                                                      classes.tableInfoCell
                                                    }
                                                  >
                                                    {gochi.amountTransferToShopWhenUseShashoku &&
                                                      gochi.amountTransferToShopWhenUseShashoku.toLocaleString()}
                                                    {`円`}
                                                  </TableCell>
                                                </TableRow>
                                                <TableRow>
                                                  <TableCell
                                                    className={
                                                      classes.tableInfoCellHeader
                                                    }
                                                  >
                                                    入金予定
                                                  </TableCell>
                                                  <TableCell
                                                    className={
                                                      classes.tableInfoCell
                                                    }
                                                  >
                                                    {gochi.depositPlanStr}
                                                  </TableCell>
                                                </TableRow>
                                                <TableRow>
                                                  <TableCell
                                                    className={
                                                      classes.tableInfoCellHeader
                                                    }
                                                  >
                                                    コメント
                                                  </TableCell>
                                                  <TableCell
                                                    className={
                                                      classes.tableInfoCell
                                                    }
                                                  >
                                                    {gochi.gochiMessage}
                                                  </TableCell>
                                                </TableRow>
                                              </TableBody>
                                            </Table>

                                            <div className={classes.lstMessage}>
                                              {gochi.shashokuShopMessage &&
                                                gochi.shashokuShopMessage
                                                  .shopMessage && (
                                                  <div
                                                    className={
                                                      classes.boxMessage
                                                    }
                                                  >
                                                    <b
                                                      className={
                                                        classes.messageTtl
                                                      }
                                                    >
                                                      店舗へのメッセージ
                                                    </b>
                                                    <div
                                                      className={
                                                        classes.messageTxt
                                                      }
                                                    >
                                                      <ReadMoreReact
                                                        text={
                                                          gochi
                                                            .shashokuShopMessage
                                                            .shopMessage
                                                        }
                                                        min={60}
                                                        ideal={65}
                                                        max={66}
                                                        readMoreText="もっと見る"
                                                      />
                                                    </div>
                                                  </div>
                                                )}

                                              {gochi.shashokuShopMessage &&
                                                gochi.shashokuShopMessage
                                                  .shopMessage && (
                                                  <div
                                                    className={
                                                      classes.boxMessageReply
                                                    }
                                                  >
                                                    <b
                                                      className={
                                                        classes.messageTtl
                                                      }
                                                    >
                                                      <ReplyIcon
                                                        className={
                                                          classes.iconReply
                                                        }
                                                      />
                                                      感謝のメッセージ
                                                      {!gochi
                                                        .shashokuShopMessage
                                                        .shopReplyMessage &&
                                                        !shashokuShopReplyText[
                                                          gochi
                                                            .shashokuShopMessage
                                                            .shashokuTicketShopMessageId
                                                        ] && (
                                                          <Button
                                                            variant="contained"
                                                            color="primary"
                                                            size="xs"
                                                            className={
                                                              classes.buttonSend
                                                            }
                                                            onClick={() => {
                                                              shopShashokuReplyMessage(
                                                                gochi
                                                                  .shashokuShopMessage
                                                                  .shashokuTicketShopMessageId
                                                              );
                                                            }}
                                                          >
                                                            送信
                                                          </Button>
                                                        )}
                                                    </b>

                                                    {gochi.shashokuShopMessage
                                                      .shopReplyMessage ? (
                                                      // eslint-disable-next-line react/jsx-indent
                                                      <div
                                                        className={
                                                          classes.messageReplyBox
                                                        }
                                                      >
                                                        <ReadMoreReact
                                                          text={
                                                            gochi
                                                              .shashokuShopMessage
                                                              .shopReplyMessage
                                                          }
                                                          min={60}
                                                          ideal={65}
                                                          max={66}
                                                          readMoreText="もっと見る"
                                                        />
                                                      </div>
                                                    ) : (
                                                      [
                                                        shashokuShopReplyText[
                                                          gochi
                                                            .shashokuShopMessage
                                                            .shashokuTicketShopMessageId
                                                        ] ? (
                                                          <div
                                                            className={
                                                              classes.messageReplyBox
                                                            }
                                                          >
                                                            {
                                                              shashokuShopReplyText[
                                                                gochi
                                                                  .shashokuShopMessage
                                                                  .shashokuTicketShopMessageId
                                                              ]
                                                            }
                                                          </div>
                                                        ) : (
                                                          <div
                                                            className={
                                                              classes.messageTxt
                                                            }
                                                          >
                                                            <TextField
                                                              id="outlined-multiline-static"
                                                              multiline
                                                              rows={4}
                                                              variant="outlined"
                                                              placeholder="例) 応援ありがとうございます。"
                                                              className={
                                                                classes.inputRoot
                                                              }
                                                              InputProps={{
                                                                className:
                                                                  classes.inputMessage
                                                              }}
                                                              value={
                                                                shashokuMessageReply[
                                                                  gochi
                                                                    .shashokuShopMessage
                                                                    .shashokuTicketShopMessageId
                                                                ]
                                                              }
                                                              onChange={e => {
                                                                onChangeShashokuReplyMess(
                                                                  e.target
                                                                    .value,
                                                                  gochi
                                                                    .shashokuShopMessage
                                                                    .shashokuTicketShopMessageId
                                                                );
                                                              }}
                                                            />
                                                          </div>
                                                        )
                                                      ]
                                                    )}
                                                  </div>
                                                )}
                                            </div>
                                          </div>
                                        )}
                                        {gochi.sourceTable === 'GOCHI' && (
                                          <>
                                            {gochi.shopId !== null ? (
                                              <div
                                                className={classes.gochiBox}
                                                key={key}
                                              >
                                                {/* <div old code toppage difference gochi list
                                              className={classNames(
                                                gochi.couponUsedCount <
                                                  gochi.totalCoupon &&
                                                  (gochi.coupons.length > 0 &&
                                                    gochi.coupons.filter(
                                                      e =>
                                                        e.gochiStatus ===
                                                        '期限切れ'
                                                    ).length === 0) &&
                                                  classes.remainCoupon,
                                                classes.gochiHeader
                                              )}
                                            >
                                              <b>ごちられ状況 </b>
                                              <span
                                                className={classNames(
                                                  classes.couponNo,
                                                  gochi.couponUsedCount <
                                                    gochi.totalCoupon &&
                                                    (gochi.coupons.length > 0 &&
                                                      gochi.coupons.filter(
                                                        e =>
                                                          e.gochiStatus ===
                                                          '期限切れ'
                                                      ).length === 0) &&
                                                    classes.textRedBig
                                                )}
                                              >
                                                {gochi.couponUsedCount}
                                                {`/`}
                                                {gochi.totalCoupon}
                                              </span>
                                              <span
                                                className={classNames(
                                                  classes.textCompare,
                                                  gochi.couponUsedCount <
                                                    gochi.totalCoupon &&
                                                    (gochi.coupons.length > 0 &&
                                                      gochi.coupons.filter(
                                                        e =>
                                                          e.gochiStatus ===
                                                          '期限切れ'
                                                      ).length === 0) &&
                                                    classes.textRed
                                                )}
                                              >
                                                {gochi.coupons.length > 0 &&
                                                gochi.coupons.filter(
                                                  e =>
                                                    e.gochiStatus === '期限切れ'
                                                ).length > 0
                                                  ? '期限切れ'
                                                  : '使用済'}
                                              </span>
                                            </div> */}

                                                {gochi.menuLimitTotal === 1 ? (
                                                  <div
                                                    className={classNames(
                                                      gochi.remainAmount !==
                                                        0 &&
                                                        (gochi.coupons.length >
                                                          0 &&
                                                          gochi.coupons.filter(
                                                            e =>
                                                              e.gochiStatus ===
                                                              '期限切れ'
                                                          ).length === 0) &&
                                                        classes.remainCoupon,
                                                      classes.gochiHeader
                                                    )}
                                                  >
                                                    <b>使用状況 </b>
                                                    <span
                                                      className={classNames(
                                                        classes.couponNo,
                                                        gochi.remainAmount !==
                                                          0 &&
                                                          (gochi.coupons
                                                            .length > 0 &&
                                                            gochi.coupons.filter(
                                                              e =>
                                                                e.gochiStatus ===
                                                                '期限切れ'
                                                            ).length === 0) &&
                                                          classes.textRedBig
                                                      )}
                                                    >
                                                      {`${gochi.usedAmount}`}
                                                      {`/`}
                                                      {`${
                                                        gochi.totalPremiumAmount
                                                      } 円`}
                                                    </span>
                                                    <span
                                                      className={classNames(
                                                        classes.textCompare,
                                                        gochi.remainAmount !==
                                                          0 &&
                                                          (gochi.coupons
                                                            .length > 0 &&
                                                            gochi.coupons.filter(
                                                              e =>
                                                                e.gochiStatus ===
                                                                '期限切れ'
                                                            ).length === 0) &&
                                                          classes.textRed
                                                      )}
                                                    >
                                                      {gochi.coupons.length >
                                                        0 &&
                                                      gochi.coupons.filter(
                                                        e =>
                                                          e.gochiStatus ===
                                                          '期限切れ'
                                                      ).length > 0
                                                        ? '期限切れ'
                                                        : '使用済'}
                                                    </span>
                                                  </div>
                                                ) : (
                                                  <div
                                                    className={classNames(
                                                      gochi.couponUsedCount <
                                                        gochi.totalCoupon &&
                                                        (gochi.coupons.length >
                                                          0 &&
                                                          gochi.coupons.filter(
                                                            e =>
                                                              e.gochiStatus ===
                                                              '期限切れ'
                                                          ).length === 0) &&
                                                        classes.remainCoupon,
                                                      classes.gochiHeader
                                                    )}
                                                  >
                                                    <b>使用状況 </b>
                                                    <span
                                                      className={classNames(
                                                        classes.couponNo,
                                                        gochi.couponUsedCount <
                                                          gochi.totalCoupon &&
                                                          (gochi.coupons
                                                            .length > 0 &&
                                                            gochi.coupons.filter(
                                                              e =>
                                                                e.gochiStatus ===
                                                                '期限切れ'
                                                            ).length === 0) &&
                                                          classes.textRedBig
                                                      )}
                                                    >
                                                      {gochi.couponUsedCount}
                                                      {`/`}
                                                      {gochi.totalCoupon}
                                                    </span>
                                                    <span
                                                      className={classNames(
                                                        classes.textCompare,
                                                        gochi.couponUsedCount <
                                                          gochi.totalCoupon &&
                                                          (gochi.coupons
                                                            .length > 0 &&
                                                            gochi.coupons.filter(
                                                              e =>
                                                                e.gochiStatus ===
                                                                '期限切れ'
                                                            ).length === 0) &&
                                                          classes.textRed
                                                      )}
                                                    >
                                                      {gochi.coupons.length >
                                                        0 &&
                                                      gochi.coupons.filter(
                                                        e =>
                                                          e.gochiStatus ===
                                                          '期限切れ'
                                                      ).length > 0
                                                        ? '期限切れ'
                                                        : '使用済'}
                                                    </span>
                                                  </div>
                                                )}

                                                <Table>
                                                  <TableBody
                                                    className={
                                                      classes.tableInfo
                                                    }
                                                  >
                                                    <TableRow
                                                      className={
                                                        classes.tableInfoRow
                                                      }
                                                    >
                                                      <TableCell
                                                        className={
                                                          classes.tableInfoCellHeader
                                                        }
                                                      >
                                                        ごち日
                                                      </TableCell>
                                                      <TableCell
                                                        className={
                                                          classes.tableInfoCell
                                                        }
                                                      >
                                                        {gochi.createdAt}
                                                      </TableCell>
                                                    </TableRow>
                                                    <TableRow>
                                                      <TableCell
                                                        className={
                                                          classes.tableInfoCellHeader
                                                        }
                                                      >
                                                        ごちった人
                                                      </TableCell>
                                                      <TableCell
                                                        className={
                                                          classes.tableInfoCell
                                                        }
                                                      >
                                                        {gochi.registerName}
                                                        {gochi.gochiRegisterAccountId !==
                                                          'gcms-web-guest' && (
                                                          <span
                                                            className={
                                                              classes.textId
                                                            }
                                                          >
                                                            {`@`}
                                                            {
                                                              gochi.gochiRegisterAccountId
                                                            }
                                                          </span>
                                                        )}
                                                      </TableCell>
                                                    </TableRow>
                                                    <TableRow>
                                                      <TableCell
                                                        className={
                                                          classes.tableInfoCellHeader
                                                        }
                                                      >
                                                        メニュー名
                                                      </TableCell>
                                                      <TableCell
                                                        className={
                                                          classes.tableInfoCell
                                                        }
                                                      >
                                                        {gochi.menuName}
                                                      </TableCell>
                                                    </TableRow>
                                                    <TableRow>
                                                      <TableCell
                                                        className={
                                                          classes.tableInfoCellHeader
                                                        }
                                                      >
                                                        個数
                                                      </TableCell>
                                                      <TableCell
                                                        className={
                                                          classes.tableInfoCell
                                                        }
                                                      >
                                                        {gochi.totalCoupon}
                                                      </TableCell>
                                                    </TableRow>
                                                    <TableRow>
                                                      <TableCell
                                                        className={
                                                          classes.tableInfoCellHeader
                                                        }
                                                      >
                                                        税込価格
                                                      </TableCell>
                                                      <TableCell
                                                        className={
                                                          classes.tableInfoCell
                                                        }
                                                      >
                                                        {(
                                                          gochi.amount +
                                                          gochi.taxAmount
                                                        ).toLocaleString()}
                                                        {`円`}
                                                      </TableCell>
                                                    </TableRow>
                                                    <TableRow>
                                                      <TableCell
                                                        className={
                                                          classes.tableInfoCellHeader
                                                        }
                                                      >
                                                        入金予定
                                                      </TableCell>
                                                      <TableCell
                                                        className={
                                                          classes.tableInfoCell
                                                        }
                                                      >
                                                        {gochi.depositPlanStr}
                                                      </TableCell>
                                                    </TableRow>
                                                    {!!gochi.subscriptionId &&
                                                      enabledStripeBilling ===
                                                        true && (
                                                        <TableRow>
                                                          <TableCell
                                                            className={
                                                              classes.tableInfoCellHeader
                                                            }
                                                          >
                                                            購入頻度
                                                          </TableCell>
                                                          <TableCell
                                                            className={
                                                              classes.tableInfoCell
                                                            }
                                                          >
                                                            {`${
                                                              gochi.subscriptionIntervalCount
                                                            }${
                                                              gochi.subscriptionInterval ===
                                                              'WEEK'
                                                                ? '週間'
                                                                : 'ヶ月'
                                                            }1回`}
                                                          </TableCell>
                                                        </TableRow>
                                                      )}
                                                    <TableRow>
                                                      <TableCell
                                                        className={
                                                          classes.tableInfoCellHeader
                                                        }
                                                      >
                                                        店舗振込額（合計）
                                                      </TableCell>
                                                      <TableCell
                                                        className={
                                                          classes.tableInfoCell
                                                        }
                                                      >
                                                        {gochi.totalPremiumAmountWhenBuy &&
                                                          gochi.totalPremiumAmountWhenBuy.toLocaleString()}
                                                        {`円`}
                                                      </TableCell>
                                                    </TableRow>
                                                    <TableRow>
                                                      <TableCell
                                                        className={
                                                          classes.tableInfoCellHeader
                                                        }
                                                      >
                                                        （内訳）
                                                      </TableCell>
                                                      <TableCell
                                                        className={
                                                          classes.tableInfoCell
                                                        }
                                                      />
                                                    </TableRow>
                                                    <TableRow>
                                                      <TableCell
                                                        className={
                                                          classes.tableInfoCellHeader
                                                        }
                                                      >
                                                        購入金額
                                                      </TableCell>
                                                      <TableCell
                                                        className={
                                                          classes.tableInfoCell
                                                        }
                                                      >
                                                        {gochi.totalNotPremiumAmountWhenBuy &&
                                                          gochi.totalNotPremiumAmountWhenBuy.toLocaleString()}
                                                        {`円`}
                                                      </TableCell>
                                                    </TableRow>
                                                    <TableRow>
                                                      <TableCell
                                                        className={
                                                          classes.tableInfoCellHeader
                                                        }
                                                      >
                                                        プレミアム金額
                                                      </TableCell>
                                                      <TableCell
                                                        className={
                                                          classes.tableInfoCell
                                                        }
                                                      >
                                                        {gochi.onlyPremiumAmountWhenBuy &&
                                                          gochi.onlyPremiumAmountWhenBuy.toLocaleString()}
                                                        {`円`}
                                                      </TableCell>
                                                    </TableRow>
                                                  </TableBody>
                                                </Table>

                                                <div
                                                  className={classes.lstMessage}
                                                >
                                                  {gochi.shopMessage && (
                                                    <div
                                                      className={
                                                        classes.boxMessage
                                                      }
                                                    >
                                                      <b
                                                        className={
                                                          classes.messageTtl
                                                        }
                                                      >
                                                        店舗へのメッセージ
                                                      </b>
                                                      <div
                                                        className={
                                                          classes.messageTxt
                                                        }
                                                      >
                                                        <ReadMoreReact
                                                          text={
                                                            gochi.shopMessage
                                                          }
                                                          min={60}
                                                          ideal={65}
                                                          max={66}
                                                          readMoreText="もっと見る"
                                                        />
                                                      </div>
                                                    </div>
                                                  )}

                                                  {gochi.shopMessage && (
                                                    <div
                                                      className={
                                                        classes.boxMessageReply
                                                      }
                                                    >
                                                      <b
                                                        className={
                                                          classes.messageTtl
                                                        }
                                                      >
                                                        <ReplyIcon
                                                          className={
                                                            classes.iconReply
                                                          }
                                                        />
                                                        感謝のメッセージ
                                                        {!gochi.shopReplyMessage &&
                                                          !shopReplyText[
                                                            gochi.gochiBillId
                                                          ] && (
                                                            <Button
                                                              variant="contained"
                                                              color="primary"
                                                              size="xs"
                                                              className={
                                                                classes.buttonSend
                                                              }
                                                              onClick={() => {
                                                                shopReplyMessage(
                                                                  gochi.gochiBillId
                                                                );
                                                              }}
                                                            >
                                                              送信
                                                            </Button>
                                                          )}
                                                      </b>

                                                      {gochi.shopReplyMessage ? (
                                                        <div
                                                          className={
                                                            classes.messageReplyBox
                                                          }
                                                        >
                                                          <ReadMoreReact
                                                            text={
                                                              gochi.shopReplyMessage
                                                            }
                                                            min={60}
                                                            ideal={65}
                                                            max={66}
                                                            readMoreText="もっと見る"
                                                          />
                                                        </div>
                                                      ) : (
                                                        [
                                                          shopReplyText[
                                                            gochi.gochiBillId
                                                          ] ? (
                                                            <div
                                                              className={
                                                                classes.messageReplyBox
                                                              }
                                                            >
                                                              {
                                                                shopReplyText[
                                                                  gochi
                                                                    .gochiBillId
                                                                ]
                                                              }
                                                            </div>
                                                          ) : (
                                                            <div
                                                              className={
                                                                classes.messageTxt
                                                              }
                                                            >
                                                              <TextField
                                                                id="outlined-multiline-static"
                                                                multiline
                                                                rows={4}
                                                                // defaultValue="Default Value"
                                                                variant="outlined"
                                                                placeholder="例) 応援ありがとうございます。"
                                                                className={
                                                                  classes.inputRoot
                                                                }
                                                                InputProps={{
                                                                  className:
                                                                    classes.inputMessage
                                                                }}
                                                                value={
                                                                  messageReply[
                                                                    gochi
                                                                      .gochiBillId
                                                                  ]
                                                                }
                                                                onChange={e => {
                                                                  onChangeReplyMess(
                                                                    e.target
                                                                      .value,
                                                                    gochi.gochiBillId
                                                                  );
                                                                }}
                                                              />
                                                            </div>
                                                          )
                                                        ]
                                                      )}
                                                    </div>
                                                  )}

                                                  {gochi.gochiMessage && (
                                                    <div
                                                      className={
                                                        classes.boxMessage
                                                      }
                                                    >
                                                      <b
                                                        className={
                                                          classes.messageTtl
                                                        }
                                                      >
                                                        ごちった人のメッセージ
                                                      </b>
                                                      <div
                                                        className={
                                                          classes.messageTxt
                                                        }
                                                      >
                                                        <ReadMoreReact
                                                          text={
                                                            gochi.gochiMessage
                                                          }
                                                          min={60}
                                                          ideal={65}
                                                          max={66}
                                                          readMoreText="もっと見る"
                                                        />
                                                      </div>
                                                    </div>
                                                  )}

                                                  {gochi.coupons &&
                                                    gochi.coupons.map(
                                                      coupon => {
                                                        const keyCoupon = `${
                                                          coupon.couponId
                                                        }`;
                                                        return (
                                                          coupon.thanksMessage && (
                                                            <div
                                                              className={
                                                                classes.boxMessage
                                                              }
                                                              key={keyCoupon}
                                                            >
                                                              <b
                                                                className={
                                                                  classes.messageTtl
                                                                }
                                                              >
                                                                ごちられた人のメッセージ
                                                              </b>
                                                              <div
                                                                className={
                                                                  classes.messageTxt
                                                                }
                                                              >
                                                                <ReadMoreReact
                                                                  text={
                                                                    coupon.thanksMessage
                                                                  }
                                                                  min={60}
                                                                  ideal={65}
                                                                  max={66}
                                                                  readMoreText="もっと見る"
                                                                />
                                                              </div>
                                                            </div>
                                                          )
                                                        );
                                                      }
                                                    )}
                                                </div>
                                              </div>
                                            ) : (
                                              gochi.coupons &&
                                              gochi.coupons.length > 0 &&
                                              gochi.coupons.map(coupon => {
                                                const keyCoupon = `${`coupon${
                                                  coupon.couponId
                                                }`}`;
                                                const LOCAL_WALLET =
                                                  '地域通貨チケット';
                                                countGochi += 1;
                                                return (
                                                  countGochi <= 3 &&
                                                  (gochi.gochiTypeStr ===
                                                  LOCAL_WALLET ? (
                                                    <div
                                                      key={keyCoupon}
                                                      className={
                                                        classes.gochiBox
                                                      }
                                                    >
                                                      <div
                                                        className={classNames(
                                                          classes.gochiHeader,
                                                          classes.gochiCoupon,
                                                          classes.gochiChargeHeader
                                                        )}
                                                      >
                                                        <b>
                                                          地域通貨チケット利用状況
                                                        </b>
                                                      </div>

                                                      <Table>
                                                        <TableBody
                                                          className={
                                                            classes.tableInfo
                                                          }
                                                        >
                                                          <TableRow
                                                            className={
                                                              classes.tableInfoRow
                                                            }
                                                          >
                                                            <TableCell
                                                              className={
                                                                classes.tableInfoCellHeader
                                                              }
                                                            >
                                                              利用日
                                                            </TableCell>
                                                            <TableCell
                                                              className={
                                                                classes.tableInfoCell
                                                              }
                                                            >
                                                              {coupon.useDate}
                                                            </TableCell>
                                                          </TableRow>
                                                          <TableRow>
                                                            <TableCell
                                                              className={
                                                                classes.tableInfoCellHeader
                                                              }
                                                            >
                                                              ごちった人
                                                            </TableCell>
                                                            <TableCell
                                                              className={
                                                                classes.tableInfoCell
                                                              }
                                                            >
                                                              {
                                                                gochi.registerName
                                                              }
                                                              {gochi.gochiRegisterAccountId !==
                                                                'gcms-web-guest' && (
                                                                <span
                                                                  className={
                                                                    classes.textId
                                                                  }
                                                                >
                                                                  {`@`}
                                                                  {
                                                                    gochi.gochiRegisterAccountId
                                                                  }
                                                                </span>
                                                              )}
                                                            </TableCell>
                                                          </TableRow>
                                                          <TableRow>
                                                            <TableCell
                                                              className={
                                                                classes.tableInfoCellHeader
                                                              }
                                                            >
                                                              利用した人
                                                            </TableCell>
                                                            <TableCell
                                                              className={
                                                                classes.tableInfoCell
                                                              }
                                                            >
                                                              {
                                                                coupon.gochiUserName
                                                              }
                                                            </TableCell>
                                                          </TableRow>
                                                          <TableRow>
                                                            <TableCell
                                                              className={
                                                                classes.tableInfoCellHeader
                                                              }
                                                            >
                                                              メニュー名
                                                            </TableCell>
                                                            <TableCell
                                                              className={
                                                                classes.tableInfoCell
                                                              }
                                                            >
                                                              {gochi.menuName}
                                                            </TableCell>
                                                          </TableRow>

                                                          <TableRow>
                                                            <TableCell
                                                              className={
                                                                classes.tableInfoCellHeader
                                                              }
                                                            >
                                                              店舗振込額（合計）
                                                            </TableCell>
                                                            <TableCell
                                                              className={
                                                                classes.tableInfoCell
                                                              }
                                                            >
                                                              {coupon.amountTransferToShopWhenUse &&
                                                                coupon.amountTransferToShopWhenUse.toLocaleString()}
                                                              {`円`}
                                                            </TableCell>
                                                          </TableRow>
                                                        </TableBody>
                                                      </Table>
                                                    </div>
                                                  ) : (
                                                    <div
                                                      key={keyCoupon}
                                                      className={
                                                        classes.gochiBox
                                                      }
                                                    >
                                                      <div
                                                        className={classNames(
                                                          classes.gochiHeader,
                                                          classes.gochiCoupon
                                                        )}
                                                      >
                                                        <b>
                                                          共通チケット利用状況
                                                        </b>
                                                      </div>

                                                      <Table>
                                                        <TableBody
                                                          className={
                                                            classes.tableInfo
                                                          }
                                                        >
                                                          <TableRow
                                                            className={
                                                              classes.tableInfoRow
                                                            }
                                                          >
                                                            <TableCell
                                                              className={
                                                                classes.tableInfoCellHeader
                                                              }
                                                            >
                                                              利用日
                                                            </TableCell>
                                                            <TableCell
                                                              className={
                                                                classes.tableInfoCell
                                                              }
                                                            >
                                                              {coupon.useDate}
                                                            </TableCell>
                                                          </TableRow>
                                                          <TableRow>
                                                            <TableCell
                                                              className={
                                                                classes.tableInfoCellHeader
                                                              }
                                                            >
                                                              ごちった人
                                                            </TableCell>
                                                            <TableCell
                                                              className={
                                                                classes.tableInfoCell
                                                              }
                                                            >
                                                              {
                                                                gochi.registerName
                                                              }
                                                              {gochi.gochiRegisterAccountId !==
                                                                'gcms-web-guest' && (
                                                                <span
                                                                  className={
                                                                    classes.textId
                                                                  }
                                                                >
                                                                  {`@`}
                                                                  {
                                                                    gochi.gochiRegisterAccountId
                                                                  }
                                                                </span>
                                                              )}
                                                            </TableCell>
                                                          </TableRow>
                                                          <TableRow>
                                                            <TableCell
                                                              className={
                                                                classes.tableInfoCellHeader
                                                              }
                                                            >
                                                              利用した人
                                                            </TableCell>
                                                            <TableCell
                                                              className={
                                                                classes.tableInfoCell
                                                              }
                                                            >
                                                              {
                                                                coupon.gochiUserName
                                                              }
                                                            </TableCell>
                                                          </TableRow>
                                                          <TableRow>
                                                            <TableCell
                                                              className={
                                                                classes.tableInfoCellHeader
                                                              }
                                                            >
                                                              メニュー名
                                                            </TableCell>
                                                            <TableCell
                                                              className={
                                                                classes.tableInfoCell
                                                              }
                                                            >
                                                              {gochi.menuName}
                                                            </TableCell>
                                                          </TableRow>

                                                          <TableRow>
                                                            <TableCell
                                                              className={
                                                                classes.tableInfoCellHeader
                                                              }
                                                            >
                                                              店舗振込額（合計）
                                                            </TableCell>
                                                            <TableCell
                                                              className={
                                                                classes.tableInfoCell
                                                              }
                                                            >
                                                              {coupon.totalPremiumAmountWhenUse &&
                                                                coupon.totalPremiumAmountWhenUse.toLocaleString()}
                                                              {`円`}
                                                            </TableCell>
                                                          </TableRow>
                                                          <TableRow>
                                                            <TableCell
                                                              className={
                                                                classes.tableInfoCellHeader
                                                              }
                                                            >
                                                              （内訳）
                                                            </TableCell>
                                                            <TableCell
                                                              className={
                                                                classes.tableInfoCell
                                                              }
                                                            />
                                                          </TableRow>
                                                          <TableRow>
                                                            <TableCell
                                                              className={
                                                                classes.tableInfoCellHeader
                                                              }
                                                            >
                                                              購入金額
                                                            </TableCell>
                                                            <TableCell
                                                              className={
                                                                classes.tableInfoCell
                                                              }
                                                            >
                                                              {coupon.totalNotPremiumAmountWhenUse &&
                                                                coupon.totalNotPremiumAmountWhenUse.toLocaleString()}
                                                              {`円`}
                                                            </TableCell>
                                                          </TableRow>
                                                          <TableRow>
                                                            <TableCell
                                                              className={
                                                                classes.tableInfoCellHeader
                                                              }
                                                            >
                                                              プレミアム金額
                                                            </TableCell>
                                                            <TableCell
                                                              className={
                                                                classes.tableInfoCell
                                                              }
                                                            >
                                                              {coupon.onlyPremiumAmountWhenUse &&
                                                                coupon.onlyPremiumAmountWhenUse.toLocaleString()}
                                                              {`円`}
                                                            </TableCell>
                                                          </TableRow>
                                                        </TableBody>
                                                      </Table>
                                                    </div>
                                                  ))
                                                );
                                              })
                                            )}
                                          </>
                                        )}
                                        {gochi.sourceTable === 'GOCHI_KID' && (
                                          <div
                                            className={classes.gochiBox}
                                            key={key}
                                          >
                                            <div
                                              className={classNames(
                                                classes.remainCoupon,
                                                classes.gochiHeader
                                              )}
                                            >
                                              <span>
                                                <b>こどもこちめし利用状況</b>
                                              </span>
                                            </div>

                                            <Table>
                                              <TableBody
                                                className={classes.tableInfo}
                                              >
                                                <TableRow
                                                  className={
                                                    classes.tableInfoRow
                                                  }
                                                >
                                                  <TableCell
                                                    className={
                                                      classes.tableInfoCellHeader
                                                    }
                                                  >
                                                    利用日
                                                  </TableCell>
                                                  <TableCell
                                                    className={
                                                      classes.tableInfoCell
                                                    }
                                                  >
                                                    {gochi.useDate}
                                                  </TableCell>
                                                </TableRow>
                                                <TableRow>
                                                  <TableCell
                                                    className={
                                                      classes.tableInfoCellHeader
                                                    }
                                                  >
                                                    利用者名
                                                  </TableCell>
                                                  <TableCell
                                                    className={
                                                      classes.tableInfoCell
                                                    }
                                                  >
                                                    {gochi.registerName}
                                                  </TableCell>
                                                </TableRow>
                                                <TableRow>
                                                  <TableCell
                                                    className={
                                                      classes.tableInfoCellHeader
                                                    }
                                                  >
                                                    資金グループ名
                                                  </TableCell>
                                                  <TableCell
                                                    className={
                                                      classes.tableInfoCell
                                                    }
                                                  >
                                                    {gochi.gochiKidGroupName}
                                                  </TableCell>
                                                </TableRow>
                                                <TableRow>
                                                  <TableCell
                                                    className={
                                                      classes.tableInfoCellHeader
                                                    }
                                                  >
                                                    利用こども氏名
                                                  </TableCell>
                                                  <TableCell
                                                    className={
                                                      classes.tableInfoCell
                                                    }
                                                  >
                                                    {gochi.userKids &&
                                                      gochi.userKids.length >
                                                        0 &&
                                                      gochi.userKids.map(
                                                        (userKid, index) => {
                                                          return (
                                                            <>
                                                              {
                                                                userKid.displayName
                                                              }
                                                              {index ===
                                                              gochi.userKids
                                                                .length -
                                                                1 ? (
                                                                ''
                                                              ) : (
                                                                <br />
                                                              )}
                                                            </>
                                                          );
                                                        }
                                                      )}
                                                  </TableCell>
                                                </TableRow>
                                                <TableRow>
                                                  <TableCell
                                                    className={
                                                      classes.tableInfoCellHeader
                                                    }
                                                  >
                                                    メニュー名
                                                  </TableCell>
                                                  <TableCell
                                                    className={
                                                      classes.tableInfoCell
                                                    }
                                                  >
                                                    {gochi.menuName}
                                                  </TableCell>
                                                </TableRow>
                                                <TableRow>
                                                  <TableCell
                                                    className={
                                                      classes.tableInfoCellHeader
                                                    }
                                                  >
                                                    使用時の店舗振込額
                                                  </TableCell>
                                                  <TableCell
                                                    className={
                                                      classes.tableInfoCell
                                                    }
                                                  >
                                                    {gochi.amountTransferToShopWhenUseTotal &&
                                                      gochi.amountTransferToShopWhenUseTotal.toLocaleString()}
                                                    {`円`}
                                                  </TableCell>
                                                </TableRow>
                                                <TableRow>
                                                  <TableCell
                                                    className={
                                                      classes.tableInfoCellHeader
                                                    }
                                                  >
                                                    入金予定
                                                  </TableCell>
                                                  <TableCell
                                                    className={
                                                      classes.tableInfoCell
                                                    }
                                                  >
                                                    利用日の翌月振込
                                                  </TableCell>
                                                </TableRow>
                                                <TableRow>
                                                  <TableCell
                                                    className={
                                                      classes.tableInfoCellHeader
                                                    }
                                                  >
                                                    感謝メッセージ
                                                  </TableCell>
                                                  <TableCell
                                                    className={
                                                      classes.tableInfoCell
                                                    }
                                                  >
                                                    {gochi.gochiMessage}
                                                  </TableCell>
                                                </TableRow>
                                              </TableBody>
                                            </Table>
                                          </div>
                                        )}
                                      </>
                                    )}
                                  </>
                                );
                              })}
                          </div>
                        </div>
                      </Paper>
                    </Box>
                  </AccordionDetails>
                </Accordion>
              </div>
            </>
          )}

          <div className={classes.mainWrapper}>
            <Accordion defaultExpanded className={classes.boxCollapse}>
              <div className={classes.textTitleDiv}>
                <AccordionSummary
                  expandIcon={
                    <ExpandMoreIcon className={classes.arrowCustom} />
                  }
                  aria-controls="shop-info-pannel"
                  id="shop-info-pannel"
                  className={classes.collapseBtn}
                >
                  <Typography className={classes.textTitle}>
                    {isFukuoka ? '教室情報' : '店舗情報'}
                  </Typography>
                </AccordionSummary>

                <Button
                  onClick={openShopPage}
                  color="primary"
                  className={classes.linkRight}
                >
                  全て見る
                </Button>
              </div>

              <AccordionDetails>
                <Box className={classes.boxCnt}>
                  <Paper className={classes.mainPaper} elevation={1}>
                    <div className={classes.shopHeader}>
                      <div className={classes.titleGroupNameDiv}>
                        <Text className={classes.titleGroupName}>
                          グループ名
                        </Text>
                      </div>
                      <div className={classes.textGroupNameDiv}>
                        <Text className={classes.textGroupName}>
                          {topInfo.shop && topInfo.shop.groupName}
                        </Text>
                      </div>
                    </div>
                    <Typography className={classes.textShopId}>
                      {isFukuoka ? '教室ID: ' : `店舗ID: `}
                      {topInfo.shop && topInfo.shop.shopId}
                    </Typography>
                    <Typography className={classes.textShopName}>
                      {topInfo.shop && topInfo.shop.shopName}
                    </Typography>
                    <Table className={classes.tableInfo}>
                      <TableBody>
                        <TableRow>
                          <TableCell className={classes.tableInfoCellHeader}>
                            住所
                          </TableCell>
                          <TableCell className={classes.tableInfoCell}>
                            {topInfo.shop && (
                              <>
                                {topInfo.shop.prefectures}
                                {` `}
                                {topInfo.shop.city}
                                {` `}
                                {topInfo.shop.address1}
                                {` `}
                                {topInfo.shop.address2}
                                {` `}
                                {topInfo.shop.building}
                              </>
                            )}
                          </TableCell>
                        </TableRow>
                        <TableRow>
                          <TableCell className={classes.tableInfoCellHeader}>
                            {isFukuoka ? (
                              <>
                                教室電話
                                <br />
                                番号
                              </>
                            ) : (
                              '電話番号'
                            )}
                          </TableCell>
                          <TableCell className={classes.tableInfoCell}>
                            {topInfo.shop && topInfo.shop.phone}
                          </TableCell>
                        </TableRow>
                        {!isFukuoka && (
                          <TableRow>
                            <TableCell className={classes.tableInfoCellHeader}>
                              さきめしページ
                            </TableCell>
                            <TableCell className={classes.tableInfoCell}>
                              <CoppyButton
                                linkToCopy={`https://gochi.online/shopdetails/${topInfo.shop &&
                                  topInfo.shop.shopId}`}
                              />
                            </TableCell>
                          </TableRow>
                        )}
                      </TableBody>
                    </Table>
                    <div className={classes.buttonDiv}>
                      <DetailTextButton onClickAction={detailOpenAction} />
                      <EditTextButton onClickAction={editOpenAction} />
                    </div>
                  </Paper>
                </Box>
              </AccordionDetails>
            </Accordion>
          </div>

          {!isFukuoka && (
            <div className={classes.mainWrapper}>
              <Accordion defaultExpanded className={classes.boxCollapse}>
                <div className={classes.textTitleDiv}>
                  <AccordionSummary
                    expandIcon={
                      <ExpandMoreIcon className={classes.arrowCustom} />
                    }
                    aria-controls="menus-pannel"
                    id="menus-pannel"
                    className={classes.collapseBtn}
                  >
                    <Typography className={classes.textTitle}>
                      メニュー情報
                    </Typography>
                  </AccordionSummary>

                  <Button
                    onClick={openMenusPage}
                    color="primary"
                    className={classes.linkRight}
                  >
                    全て見る
                  </Button>
                </div>

                <AccordionDetails>
                  <Box className={classes.boxCnt}>
                    <Paper className={classes.mainPaperWhite}>
                      <div className={classes.btnCenter}>
                        <MenuRegisterButton onClickAction={addAction} />
                      </div>
                      <GochiMenuTableShop
                        roles={roles}
                        listMenus={topInfo.menus}
                        handleChangePage={handleChangePage}
                        progress={progress}
                        menuGenre={menuGenre}
                        menuSituation={menuSituation}
                        menuUserTarget={menuUserTarget}
                      />
                    </Paper>
                  </Box>
                </AccordionDetails>
              </Accordion>
            </div>
          )}
          <div>
            <Modal open={openShopOpen} className={classes.mainModal}>
              <ShopOpen
                setOpenShopOpen={setOpenShopOpen}
                updateDisabled={updateDisabled}
              />
            </Modal>
          </div>
          <Modal
            open={openDetailModal}
            onClose={() => {
              updateOpenDetailModal(false);
            }}
            className={classes.modalMobile}
          >
            <ShopDetailShop
              updateOpenDetailModal={updateOpenDetailModal}
              detail={detail}
              isFukuoka={isFukuoka}
            />
          </Modal>
          <Modal open={openEditModal} className={classes.modalMobile}>
            <ShopEditShop
              updateOpenEditModal={updateOpenEditModal}
              openEditConfirm={openEditConfirm}
              updateOpenEditConfirm={updateOpenEditConfirm}
              editInput={detail}
              handleChangePage={handleChangePage}
              isFukuoka={isFukuoka}
              listBank={listBank}
              listBankBranch={listBankBranch}
              educateSystem={educateSystem}
            />
          </Modal>
          <div>
            <Modal open={openNotifyPopup}>
              <NotifyPopupShop
                setOpenNotifyPopup={setOpenNotifyPopup}
                textTitle={textTitle}
                textMessage={textMessage}
              />
            </Modal>
          </div>
          <div>
            <Modal open={openAdd} className={classes.modalMobile}>
              <GochiMenuAddShop
                openAddConfirm={openAddConfirm}
                updateOpenAdd={updateOpenAdd}
                updateOpenAddConfirm={updateOpenAddConfirm}
                shopId={shopId}
                setShopId={setShopId}
                handleChangePage={handleChangePage}
                roles={roles}
                menuGenre={menuGenre}
                menuSituation={menuSituation}
                menuUserTarget={menuUserTarget}
              />
            </Modal>
          </div>

          <div>
            <Modal
              open={openAddChooseUsageType}
              className={classes.modalMobile}
            >
              <GochiMenuAddChooseUsageTypeShop
                updateOpenAddChooseUsageType={updateOpenAddChooseUsageType}
                shopId={shopId}
                setShopId={setShopId}
                handleChangePage={handleChangePage}
                menuGenre={menuGenre}
                openAddChooseUsageType={openAddChooseUsageType}
              />
            </Modal>
          </div>

          <Modal
            open={openDetailRss}
            onClose={() => {
              setOpenDetailRss(false);
            }}
            className={classes.modalMobile}
          >
            <DetailPostModal
              setDetailPost={setOpenDetailRss}
              params={contentRss}
            />
          </Modal>
          <ProgressDialog
            openProgress={openProgress}
            progressOkAction={progressOkAction}
            loading={loading}
            resultMessage={resultMessage}
          />

          {!isFukuoka && (
            <PolicyFirstLoginShopDialog
              show={openPolicyFirstLoginModal}
              isSmall
              okAction={handleClickAccessPolicy}
            />
          )}
        </div>
      </>
    );
  }
);

export default withRouter(withStyles(styles)(Main));
